
<div class="atp-wizard-shell">
    <mat-card [style.background-color]="uiData.atp.color" style="margin: 0; border-radius: 4px; flex-shrink: 0;">
        <mat-card-title>
            <mat-icon>{{uiData.atp.icon}}</mat-icon> 
        {{ dialogTitle }}
        </mat-card-title>
    </mat-card>
    
    <div *ngIf="loading" class="spinner-container">
        <mat-spinner diameter="60" strokeWidth="6"></mat-spinner>
    </div>

    <form class="atp-form-shell" [formGroup]="atpApplicationForm" *ngIf="!loading">
        <mat-card class="status-summary-card" *ngIf="showApplicationStatusSummary">
          <div class="status-summary-grid">
            <div class="status-summary-item">
              <div class="status-summary-label">Application Status</div>
              <div class="status-summary-pill" [ngStyle]="{ '--status-color': sharedService.getStatusColor(displayApplicationStatus) }">
                {{ displayApplicationStatus }}
              </div>
            </div>

            <div class="status-summary-item" *ngIf="applicationStatusDate">
              <div class="status-summary-label">{{ applicationStatusDateLabel }}</div>
              <div class="status-summary-value">{{ applicationStatusDate | date:'MM/dd/yyyy' }}</div>
            </div>
          </div>
        </mat-card>

        <!-- Application Type Selection (scrollable) -->
        <div class="scroll-container" *ngIf="selectedApplicationType==''">
            <div fxLayout="column" fxLayoutGap="8px;">
                <!-- Application Type -->
                <div fxLayout="column">
                    <div fxLayout="column">
                        <br>
                        <span>
                            Detailed information regarding Accredited Training Providers can be found online.
                        </span>
                        <span>                            
                          <a href="https://www.oregon.gov/oha/PH/HEALTHYENVIRONMENTS/HEALTHYNEIGHBORHOODS/LEADPOISONING/Pages/Lead-BasedPaintRegulations.aspx"
                              target="_blank"
                              rel="noopener"
                              style="word-break: break-all;
                                  white-space: normal;">
                          https://www.oregon.gov/oha/ph/healthyenvironments/healthyneighborhoods/leadpoisoning/trainingproviders/pages/index.aspx
                          </a>                            
                        </span>
                    </div>
                        
                    <div fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" style="margin-top: 25px" fxLayoutAlign="start stretch">
                        <div fxFlex="50" fxFlex.lt-md="100">
                            <mat-card fxLayout="column" fxLayoutGap="8px" style="height: 100%;">
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <h3>Apply for a new Accredited Training Provider</h3>
                            </div>
                            <p>Select this option to apply for accreditation as a new Accredited Training Provider. This application allows you to register your organization to provide lead-based paint training courses.</p>
                            <div fxFlex="1 1 auto"></div>
                            <div fxLayout="row" fxLayoutAlign="center">
                                <button mat-raised-button type="button" color="primary" (click)="startNewApplicationFlow()">
                                    <mat-icon>add</mat-icon> Apply for a New Accredited Training Provider
                                </button>
                            </div>
                            </mat-card>
                        </div>
                        <div fxFlex="50" fxFlex.lt-md="100">
                            <mat-card fxLayout="column" fxLayoutGap="8px" style="height: 100%;">
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <h3>Link to an existing Accredited Training Provider</h3>
                            </div>
                            <p>Select this option to link your account to an existing Accredited Training Provider. This allows you to access and manage courses for an already accredited training organization.</p>
                            <div fxFlex="1 1 auto"></div>
                            <div fxLayout="row" fxLayoutAlign="center">
                                <button mat-raised-button type="button" color="primary" (click)="selectedApplicationType = 'link'">
                                    <mat-icon>link</mat-icon> Link to an Existing Accredited Training Provider
                                </button>
                            </div>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Link Application (header fixed, content scrollable) -->
        <div fxFlex fxLayout="column" class="wizard-step-shell" *ngIf="selectedApplicationType=='link'">
            <h3 style="margin:0px; padding: 8px; flex-shrink: 0;">Link to an Existing Accredited Training Provider</h3>
            <mat-stepper [orientation]="sharedService.isMobile ? 'vertical' : 'horizontal'" #atpStepper [selectedIndex]="step" (selectionChange)="changeStep($event)" class="wizard-stepper">
              <!-- Step 1: Provide Information -->
              <mat-step>
                <ng-template matStepLabel>
                  <span>ATP Information</span>
                </ng-template>
                <div class="scroll-container">
                  <div fxLayout="column" fxLayoutGap="16px">
                    <!-- Blue Information Banner -->
                    <mat-card class="info-banner">
                      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                        <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                        <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                          Please enter the existing Accredited Training Provider (ATP) name or ATPORId below then click the next button.
                        </span>
                      </div>
                    </mat-card>
                    
                    <mat-form-field appearance="fill">
                      <mat-label>ATP Name or ATP OR Id</mat-label>
                      <input matInput 
                             formControlName="atpName" 
                             [matAutocomplete]="autoAtpLink"
                             [errorStateMatcher]="matcher"
                             (input)="onAtpNameInputForLink($event)"
                             (keydown.enter)="atpStepper.next()"
                             >
                      <mat-error *ngIf="atpApplicationForm.get('atpName')?.hasError('required') && atpApplicationForm.get('atpName')?.touched">
                        ATP Name or ATP OR Id is required
                      </mat-error>
                      <mat-autocomplete #autoAtpLink="matAutocomplete">
                        <mat-option *ngFor="let atp of filteredAtpNamesForLink" 
                                   [value]="atp.name"
                                   (onSelectionChange)="selectAtpFromAutocompleteForLink(atp)">
                          {{ getAtpDisplayNameForLink(atp) }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>
              </mat-step>

              <!-- Step 2: Signature and Acknowledgments -->
              <mat-step>
                <ng-template matStepLabel>
                  <span>Signature and Acknowledgments</span>
                </ng-template>
                <div class="scroll-container">
                  <div>
                    <div *ngIf="verificationLoading" style="display: flex; align-items: center; justify-content: center; min-height: 100px;">
                      <mat-spinner [diameter]="48" [strokeWidth]="6" style="border-radius: 50%; margin-right: 16px;"></mat-spinner>
                      <span style="font-size: 1.2rem;">Searching...</span>
                    </div>
                    <div *ngIf="!verificationLoading && atpApplicationForm.get('atpId').value !== null && atpApplicationForm.get('atpId').value !== '' && atpApplicationForm.get('atpId').value !== undefined" fxLayout="column" fxLayoutGap="16px">
                      <!-- Orange Verification Banner -->
                      <mat-card class="warning-banner">
                        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                          <mat-icon style="color: #e65100; flex-shrink: 0;">info</mat-icon>
                          <span style="color: #e65100; font-size: 14px; line-height: 1.5;">
                            Please verify that the information below is correct
                          </span>
                        </div>
                      </mat-card>
                      
                      <p>Accredited Training Provider: <strong>{{atpApplicationForm.get('atpName').value}}</strong></p>
                      <ng-container *ngIf="hasLinkApprovalContactEmails; else atpLinkFallbackNotice">
                        <p *ngIf="!hasMultipleLinkApprovalContactEmails">
                          An approval email will be sent to the contact email on file:
                          <a [href]="'mailto:' + linkApprovalContactEmails[0]" style="color: #1976d2;"><strong>{{ linkApprovalContactEmails[0] }}</strong></a>
                        </p>
                        <div *ngIf="hasMultipleLinkApprovalContactEmails">
                          <p>Approval emails will be sent to the contact emails on file:</p>
                          <ul style="margin-top: 0;">
                            <li *ngFor="let approvalEmail of linkApprovalContactEmails">
                              <a [href]="'mailto:' + approvalEmail" style="color: #1976d2;"><strong>{{ approvalEmail }}</strong></a>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                      <ng-template #atpLinkFallbackNotice>
                        <p>
                          No valid contact email was found for this ATP. This request will be sent to
                          <a href="mailto:leadprogram@odhsoha.oregon.gov" style="color: #1976d2;"><strong>leadprogram@odhsoha.oregon.gov</strong></a>
                          for staff review.
                        </p>
                      </ng-template>
                      <mat-checkbox formControlName="attestation" required [disabled]="isLinkApplicationSubmitted()">
                        I attest that I am affiliated with the Accredited Training Provider listed above.
                      </mat-checkbox>
                      <mat-error *ngIf="atpApplicationForm.get('attestation').hasError('required') || atpApplicationForm.get('attestation').hasError('requiredTrue')">
                        You must attest before submitting.
                      </mat-error>
                      <mat-form-field appearance="fill">
                        <mat-label>E-Signature</mat-label>
                        <input matInput formControlName="esignature" required [readonly]="isLinkApplicationSubmitted()">
                        <mat-error *ngIf="atpApplicationForm.get('esignature').hasError('required')">E-Signature is required</mat-error>
                      </mat-form-field>
                    </div>
                    <div *ngIf="!verificationLoading && (atpApplicationForm.get('atpId').value === null || atpApplicationForm.get('atpId').value === '' || atpApplicationForm.get('atpId').value === undefined)" fxLayout="column" fxLayoutGap="16px">
                      <mat-card class="mat-elevation-2" style="background-color: #ffebee; border-left: 4px solid #f44336; padding: 16px;">
                        <div fxLayout="column" fxLayoutGap="12px">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <mat-icon color="warn">error_outline</mat-icon>
                            <h4 style="margin: 0; color: #d32f2f;">No Matching Accredited Training Provider Found</h4>
                          </div>
                          <p style="margin: 0; color: #666;">
                            Please check your ATP OR Id or spelling and try again.
                          </p>
                          <p style="margin: 0; color: #666;">
                            If you believe you are encountering this message in error, please contact us at 
                            <a href="mailto:leadprogram@odhsoha.oregon.gov" style="color: #1976d2;">leadprogram@odhsoha.oregon.gov</a> 
                            or <a href="tel:971-673-0440" style="color: #1976d2;">971-673-0440</a>.
                          </p>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </mat-step>

              <!-- Follow-up Confirmation Step -->
              <mat-step *ngIf="atpApplicationForm.get('applicationStatus')?.value === 'Submitted'">
                <ng-template matStepLabel>
                  <span>Confirmation</span>
                </ng-template>
                <div class="scroll-container">
                  <div fxLayout="column" fxLayoutAlign="center center" style="padding: 40px; text-align: center;">
                    <mat-card style="padding: 30px; max-width: 600px;">
                      <mat-card-content style="display: flex; flex-direction: column; align-items: center;">
                        <mat-icon style="font-size: 64px; height: 64px; width: 64px; color: #4caf50; margin-bottom: 20px;">check_circle</mat-icon>
                        <h2 style="color: #4caf50; margin-bottom: 20px;">Link Request Submitted Successfully!</h2>
                        <p style="font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                          Your link request has been submitted and is being reviewed. 
                        </p>
                        <div style="padding: 16px; border-radius: 4px; margin-bottom: 20px; width: 100%;" *ngIf="hasLinkApprovalContactEmails; else atpConfirmationFallback">
                          <p style="margin: 4px 0;" *ngIf="!hasMultipleLinkApprovalContactEmails">
                            An approval email has been sent to:
                            <a [href]="'mailto:' + linkApprovalContactEmails[0]" style="color: #1976d2;"><strong>{{ linkApprovalContactEmails[0] }}</strong></a>
                          </p>
                          <div *ngIf="hasMultipleLinkApprovalContactEmails">
                            <p style="margin: 4px 0;">Approval emails have been sent to:</p>
                            <ul style="margin: 4px 0 0; text-align: left; display: inline-block;">
                              <li *ngFor="let approvalEmail of linkApprovalContactEmails">
                                <a [href]="'mailto:' + approvalEmail" style="color: #1976d2;"><strong>{{ approvalEmail }}</strong></a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <ng-template #atpConfirmationFallback>
                          <p style="font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                            No valid contact email was found for this ATP. The request has been sent to
                            <a href="mailto:leadprogram@odhsoha.oregon.gov" style="color: #1976d2;"><strong>leadprogram@odhsoha.oregon.gov</strong></a>
                            for staff review.
                          </p>
                        </ng-template>
                        <p style="font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                          If you have any questions or concerns, please contact us at:
                        </p>
                        <div style="padding: 16px; border-radius: 4px; margin-bottom: 20px;">
                          <p style="margin: 4px 0;"><strong>Email: </strong> 
                            <a href="mailto:leadprogram@odhsoha.oregon.gov" style="color: #1976d2;">leadprogram@odhsoha.oregon.gov</a>
                          </p>
                          <p style="margin: 4px 0;"><strong>Phone: </strong> 
                            <a href="tel:971-673-0440" style="color: #1976d2;">971-673-0440</a>
                          </p>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </mat-step>
            </mat-stepper>
        </div>

        <!-- New Application (header fixed, content scrollable) -->
        <div fxFlex fxLayout="column" class="wizard-step-shell" style="width: 100%; max-width: 100%;" *ngIf="selectedApplicationType=='new'">
            <h3 style="margin:0px; padding: 8px; flex-shrink: 0;">Apply for a Training Program Accreditation</h3>
            <mat-stepper [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #atpStepper [selectedIndex]="step" (selectionChange)="changeStep($event)" class="wizard-stepper">                  
              <mat-step>
                <ng-template matStepLabel>
                      <span>App Info</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutGap="16px">                        
                        <mat-label><strong>Select a program and application type.</strong></mat-label>
                        <div [class.validation-error]="atpApplicationForm.get('programType')?.invalid && (atpApplicationForm.get('programType')?.touched || atpApplicationForm.get('programType')?.dirty)">
                          <mat-radio-group formControlName="programType" class="program-type-radio-group" [disabled]="isProgramTypeLocked()" required>
                            <div fxLayout="row" fxLayoutGap="16px">
                              
                              <mat-card *ngFor="let programType of programTypes" fxFlex="50%">
                                <mat-card-header class="coloredCardHeader" appearance="fill" [ngStyle]="{'background-color': setBackgroundColor(atpApplicationForm.get('programType')?.value, programType.value)}">
                                  <mat-radio-button class="program-radio" [value]="programType.value">
                                    {{ programType.label }}
                                  </mat-radio-button>
                                </mat-card-header>
                                <p class="program-description" *ngIf="programType.value === 'rrp'">
                                  This program covers renovation, repair, and painting activities in housing, child-occupied facilities, and schools that may disturb lead-based paint.
                                </p>
                                <p class="program-description" *ngIf="programType.value === 'rrp'">
                                  <a href="https://www.oregon.gov/oha/PH/HEALTHYENVIRONMENTS/HEALTHYNEIGHBORHOODS/LEADPOISONING/TRAININGPROVIDERS/Documents/InstructionsRRPAccreditation.pdf"
                                     target="_blank"
                                     rel="noopener">
                                    Click Here for additional RRP Accreditation Instructions
                                  </a>
                                </p>
                                <p class="program-description" *ngIf="programType.value === 'lbpa'">
                                  This program covers lead-based paint inspections, risk assessments, and abatement services performed by certified professionals.
                                </p>
                              </mat-card>

                            </div>
                          </mat-radio-group>
                          <mat-error *ngIf="atpApplicationForm.get('programType')?.invalid && (atpApplicationForm.get('programType')?.touched || atpApplicationForm.get('programType')?.dirty)" style="font-size: 12px; margin-top: 4px;">
                            <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle;">error</mat-icon>
                            Program Type is required
                          </mat-error>
                        </div>

                        <mat-form-field appearance="fill">
                          <mat-label>Application Type</mat-label>
                          <mat-select formControlName="applicationType">
                            <mat-option *ngFor="let option of getAvailableApplicationTypes()" [value]="option.value">
                              {{ option.label }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="atpApplicationForm.get('applicationType')?.hasError('required')">
                            Application Type is required
                          </mat-error>
                        </mat-form-field>

                        <div fxFlex fxLayout="row" fxLayoutGap="16px" *ngIf="atpApplicationForm.get('applicationType').value==='ammendment'">
                          <mat-form-field appearance="fill" fxFlex="100%">
                            <mat-label>Ammendment Type</mat-label>
                            <mat-select formControlName="ammendmentType">
                              <mat-option *ngFor="let option of ammendmentType" [value]="option.value">
                                {{ option.label }}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="atpApplicationForm.get('ammendmentType')?.hasError('required')">
                              Ammendment Type is required
                            </mat-error>
                          </mat-form-field>

                          <mat-form-field fxFlex="50%" appearance="fill" *ngIf="atpApplicationForm.get('ammendmentType').value==='other'">
                            <mat-label>Please specify</mat-label>
                            <input matInput formControlName="other">
                            <mat-error *ngIf="atpApplicationForm.get('other')?.hasError('required')">
                              Please specify the ammendment type
                            </mat-error>
                          </mat-form-field>    
                        </div>

                        <mat-form-field appearance="fill" *ngIf="atpApplicationForm.get('applicationType').value==='ammendment'">
                          <mat-label>Accreditation or Approved Application to Amend</mat-label>
                          <mat-select formControlName="ammendmentAtpAccreditation"
                                      [compareWith]="compareAccreditationOptions"
                                      [disabled]="isTargetSelectionLocked('ammendment')"
                                      (selectionChange)="onAmmendmentTargetChange($event.value)">
                            <mat-option *ngFor="let option of ammendmentTargetOptions" [value]="option.accreditation">
                              {{ option.label }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="atpApplicationForm.get('ammendmentAtpAccreditation')?.hasError('required')">
                            Select a valid accreditation or approved application to amend
                          </mat-error>
                        </mat-form-field>

                        <mat-card class="warning-banner" *ngIf="atpApplicationForm.get('applicationType').value==='ammendment' && ammendmentTargetWarning">
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #e65100; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #e65100; font-size: 14px; line-height: 1.5;">
                              {{ ammendmentTargetWarning }}
                            </span>
                          </div>
                        </mat-card>

                        <mat-form-field appearance="fill" *ngIf="atpApplicationForm.get('applicationType').value==='reaccreditation'">
                          <mat-label>Accreditation to Reaccredit</mat-label>
                          <mat-select formControlName="renewalAtpAccreditation"
                                      [compareWith]="compareAccreditationOptions"
                                      [disabled]="isTargetSelectionLocked('reaccreditation')"
                                      (selectionChange)="onReaccreditationTargetChange($event.value)">
                            <mat-option *ngFor="let option of reaccreditationTargetOptions" [value]="option.accreditation">
                              {{ option.label }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="atpApplicationForm.get('renewalAtpAccreditation')?.hasError('required')">
                            Select an accreditation to reaccredit
                          </mat-error>
                        </mat-form-field>

                        <mat-card class="warning-banner" *ngIf="atpApplicationForm.get('applicationType').value==='reaccreditation' && reaccreditationTargetWarning">
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #e65100; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #e65100; font-size: 14px; line-height: 1.5;">
                              {{ reaccreditationTargetWarning }}
                            </span>
                          </div>
                        </mat-card>

                        <div>
                          <div fxLayout="row" fxLayoutAlign="space-between center">
                            <h4>Have you been accredited to provide lead-based paint training by EPA or in any other state or tribal jurisdictions?</h4>                      
                            <button mat-raised-button color="primary" (click)="addOtherAccreditation()" *ngIf="atpApplicationForm.get('otherJurisdictionAccreditation')?.value === true" [disabled]="!isFormEditable()">
                              <mat-icon>add</mat-icon>
                              Add Other Accreditation
                            </button>
                          </div>
                          <mat-radio-group formControlName="otherJurisdictionAccreditation">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false" style="margin-left: 16px;">No</mat-radio-button>
                          </mat-radio-group>
                        
                          <!-- Informational Banner -->
                          <mat-card class="info-banner" style="margin-top: 16px;" *ngIf="atpApplicationForm.get('otherJurisdictionAccreditation')?.value === true">
                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                              <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                              <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                List all jurisdictions where you have been accredited, provide the accreditation numbers, course disciplines, course types, approval dates, and upload supporting documentation for each accreditation.
                              </span>
                            </div>
                          </mat-card>
                      
                          <!-- Other Accreditations Table -->
                          <div style="width: 100%; overflow-x: auto;" *ngIf="atpApplicationForm.get('otherJurisdictionAccreditation')?.value === true">
                            <mat-table [dataSource]="otherAccreditationsDataSource" matSort class="mat-elevation-z8" style="table-layout: fixed;">
                              
                              <!-- Jurisdiction Column -->
                              <ng-container matColumnDef="jurisdiction">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">Jurisdiction *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="20" style="margin-top: 15px;">
                                    <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="element.get('jurisdiction')?.invalid && (element.get('jurisdiction')?.touched || element.get('jurisdiction')?.dirty)">
                                    <input matInput 
                                          [formControl]="element.get('jurisdiction')"
                                          placeholder="Enter jurisdiction"
                                          style="font-size: 12px;" 
                                      data-focus-key="other-accreditation-jurisdiction"
                                          [readonly]="!isFormEditable()"
                                          required>
                                  </mat-form-field>
                                </mat-cell>
                              </ng-container>

                              <!-- Accreditation Number Column -->
                              <ng-container matColumnDef="accreditationNumber">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">Accreditation Number *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="10" style="margin-top: 15px;">
                                    <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="element.get('accreditationNumber')?.invalid && (element.get('accreditationNumber')?.touched || element.get('accreditationNumber')?.dirty)">
                                    <input matInput 
                                          [formControl]="element.get('accreditationNumber')"
                                          placeholder="Enter number"
                                          style="font-size: 12px;" 
                                      data-focus-key="other-accreditation-number"
                                          [readonly]="!isFormEditable()"
                                          required>
                                  </mat-form-field>
                                </mat-cell>
                              </ng-container>

                              <!-- Course Discipline Column -->
                              <ng-container matColumnDef="courseDiscipline">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">Course Discipline *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="margin-top: 15px;">
                                  <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="element.get('courseDiscipline')?.invalid && (element.get('courseDiscipline')?.touched || element.get('courseDiscipline')?.dirty)">
                                    <mat-select [formControl]="element.get('courseDiscipline')"
                                                data-focus-key="other-accreditation-discipline"
                                                style="font-size: 12px;" 
                                                [disabled]="!isFormEditable()"
                                                required>
                                      <mat-option [value]="null">--Select--</mat-option>
                                      <mat-option *ngFor="let discipline of getAllCourseDisciplines()" [value]="discipline">
                                        {{ discipline }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </mat-cell>
                              </ng-container>

                              <!-- Course Type Column -->
                              <ng-container matColumnDef="courseType">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">Course Type *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="10" style="margin-top: 15px;">
                                  <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="element.get('courseType')?.invalid && (element.get('courseType')?.touched || element.get('courseType')?.dirty)">
                                    <mat-select [formControl]="element.get('courseType')"
                                                data-focus-key="other-accreditation-course-type"
                                                style="font-size: 12px;" 
                                                [disabled]="!isFormEditable()"
                                                required>
                                      <mat-option [value]="null">--Select--</mat-option>
                                      <mat-option *ngFor="let type of courseTypes" [value]="type.value">
                                        {{ type.label }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </mat-cell>
                              </ng-container>

                              <!-- Approval Date Column -->
                              <ng-container matColumnDef="approvalDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">Approval Date *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="10" style="margin-top: 15px;">
                                  <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="element.get('approvalDate')?.invalid && (element.get('approvalDate')?.touched || element.get('approvalDate')?.dirty)">
                                    <input matInput 
                                          type="date"
                                          [formControl]="element.get('approvalDate')"
                                          style="font-size: 12px;" 
                                      data-focus-key="other-accreditation-approval-date"
                                          [readonly]="!isFormEditable()"
                                          required>
                                  </mat-form-field>
                                </mat-cell>
                              </ng-container>

                              <!-- Approving Authority Column -->
                              <ng-container matColumnDef="approvingAuthority">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">Approving Authority *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="margin-top: 15px;">
                                  <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="element.get('approvingAuthority')?.invalid && (element.get('approvingAuthority')?.touched || element.get('approvingAuthority')?.dirty)">
                                    <input matInput 
                                          [formControl]="element.get('approvingAuthority')"
                                          placeholder="Enter authority"
                                          style="font-size: 12px;" 
                                      data-focus-key="other-accreditation-authority"
                                          [readonly]="!isFormEditable()"
                                          required>
                                  </mat-form-field>
                                </mat-cell>
                              </ng-container>

                              <!-- Documents Column -->
                              <ng-container matColumnDef="documents">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="13">Documents *</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="13" style="display: flex; align-items: flex-start; padding: 8px;">
                                  <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                                    <!-- Upload Button -->
                                    <div>
                                      <input type="file" 
                                            #otherAccreditationFileInput
                                            (change)="onOtherAccreditationDocumentSelected($event, i)"
                                            style="display: none;"
                                            accept=".pdf,.doc,.docx,.jpg,.png">
                                            <button mat-raised-button color="primary" (click)="otherAccreditationFileInput.click()" 
                                              style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                              data-focus-key="other-accreditation-documents"
                                              [disabled]="!isFormEditable()">
                                        <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                        Upload
                                      </button>
                                    </div>
                                    
                                    <!-- Document List -->
                                    <div fxLayout="column" fxLayoutGap="2px">
                                      <div *ngFor="let doc of element.get('documents')?.value; let docIndex = index" 
                                          fxLayout="row" fxLayoutAlign="space-between center" 
                                          style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                        <a (click)="downloadOtherAccreditationDocument(i, docIndex)" 
                                          style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                          {{ doc.name }}
                                        </a>
                                        <button mat-icon-button color="warn" 
                                                (click)="removeOtherAccreditationDocument(i, docIndex)"
                                                style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                                [disabled]="!isFormEditable()">
                                          <mat-icon style="font-size: 12px;">close</mat-icon>
                                        </button>
                                      </div>
                                      
                                      <div *ngIf="!element.get('documents')?.value || element.get('documents')?.value.length === 0" 
                                          style="font-size: 12px; color: #999; font-style: italic;">
                                        No documents
                                      </div>
                                      
                                      <!-- Error message when no documents uploaded -->
                                      <div *ngIf="(!element.get('documents')?.value || element.get('documents')?.value.length === 0)" 
                                          style="font-size: 11px; color: #f44336; margin-top: 4px;">
                                        At least one document required
                                      </div>
                                    </div>
                                  </div>
                                </mat-cell>
                              </ng-container>

                              <!-- Actions Column -->
                              <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="7">Actions</mat-header-cell>
                                <mat-cell *matCellDef="let element; let i = index" fxFlex="7">
                                  <button mat-icon-button color="warn" (click)="removeOtherAccreditation(i)" [disabled]="!isFormEditable()">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </mat-cell>
                              </ng-container>

                              <!-- Header and Row Definitions -->
                              <mat-header-row *matHeaderRowDef="otherAccreditationsDisplayedColumns"></mat-header-row>
                              <mat-row *matRowDef="let row; columns: otherAccreditationsDisplayedColumns;" style="min-height: 80px;"></mat-row>
                            </mat-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step>
                    <ng-template matStepLabel>
                      <span>Courses</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutGap="16px">
                        <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 16px;">
                          <h4>Indicate the course(s) for which you seek accreditation or re-accreditation</h4>
                          <button mat-raised-button color="primary" (click)="addCourseSelection()" [disabled]="!isFormEditable()" data-focus-id="add-course">
                            <mat-icon>add</mat-icon> Add Course
                          </button>
                        </div>

                        <div style="width: 100%; overflow-x: auto;">
                          <mat-table [dataSource]="courseDataSource" matSort class="mat-elevation-z8" style="table-layout: fixed;">
                            <!-- Discipline Column -->
                            <ng-container matColumnDef="discipline">
                              <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="20">Discipline *</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="20" style="margin-top: 15px">
                                <mat-form-field appearance="fill" style="width: calc(100% - 8px);" [class.field-error]="hasFieldError(i, 'discipline')">
                                  <mat-select [(value)]="element.discipline" (selectionChange)="updateSelection(i, 'discipline', $event.value)" [disabled]="!isFormEditable()" required data-focus-key="course-discipline">
                                    <mat-option [value]="null">--Select--</mat-option>
                                    <mat-option *ngFor="let discipline of getCourseDisciplines()" [value]="discipline">
                                      {{ discipline }}
                                    </mat-option>
                                  </mat-select>
                                  <mat-error *ngIf="element.formControl?.get('discipline')?.hasError('required')">
                                    Discipline is required
                                  </mat-error>
                                </mat-form-field>
                              </mat-cell>
                            </ng-container>

                            <!-- Type Column -->
                            <ng-container matColumnDef="type">
                              <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">Type</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="margin-top: 15px">
                                <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                  <mat-select [(value)]="element.type" (selectionChange)="updateSelection(i, 'type', $event.value)" [disabled]="!isFormEditable()">                                  
                                    <mat-option *ngFor="let type of courseTypes" [value]="type.value">
                                      {{ type.label }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </mat-cell>
                            </ng-container>

                            <!-- Language Column -->
                            <ng-container matColumnDef="language">
                              <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">Language</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="margin-top: 15px">
                                <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                  <mat-select [(value)]="element.language" (selectionChange)="updateSelection(i, 'language', $event.value)" [disabled]="!isFormEditable()">                                  
                                    <mat-option *ngFor="let lang of courseLanguages" [value]="lang.value">
                                      {{ lang.label }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </mat-cell>
                            </ng-container>

                            <!-- Format Column -->
                            <ng-container matColumnDef="format">
                              <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15">Format</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="margin-top: 15px">
                                <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                  <mat-select [(value)]="element.format" (selectionChange)="updateSelection(i, 'format', $event.value)" [disabled]="!isFormEditable()">                                  
                                    <mat-option *ngFor="let format of courseFormats" [value]="format.value">
                                      {{ format.label }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </mat-cell>
                            </ng-container>

                            <!-- Accreditation Column -->
                            <ng-container matColumnDef="accreditation">
                              <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="18">Accreditation</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="18" style="margin-top: 15px">
                                <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                  <mat-select [(value)]="element.accreditation" [disabled]="true">                                  
                                    <mat-option *ngFor="let accreditation of courseAccreditations" [value]="accreditation.value">
                                      {{ accreditation.label }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </mat-cell>
                            </ng-container>

                            <!-- Fee Column -->
                            <ng-container matColumnDef="fee">
                              <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="10">Fee</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="10">
                                <span style="padding: 8px;">${{ element.fee || '0.00' }}</span>
                              </mat-cell>
                            </ng-container>

                            <!-- Actions Column -->
                            <ng-container matColumnDef="actions">
                              <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                              <mat-cell *matCellDef="let element; let i = index" fxFlex="10">
                                <button mat-icon-button color="warn" (click)="removeSelection(i)" [disabled]="!isFormEditable()">
                                  <mat-icon>delete</mat-icon>
                                </button>
                              </mat-cell>
                            </ng-container>

                            <!-- Header and Row Definitions -->
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                          </mat-table>

                          <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 16px; padding-right: 11%;">
                            <mat-card class="mat-elevation-2" style="background-color: #e8f5e8; padding: 16px;">
                              <div fxLayout="column" fxLayoutAlign="center center">
                                <span style="font-size: 14px; color: #666; font-weight: 500;">Course Fees</span>
                                <span style="font-size: 20px; font-weight: bold; color: #2e7d32;">
                                  {{ getTotalFees() | currency:'USD':'symbol':'1.2-2' }}
                                </span>
                              </div>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                    </div> 
                  </mat-step>

                  <mat-step *ngIf="showReaccreditStep()">
                    <ng-template matStepLabel>
                      <span>ReAccredit</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutGap="24px">

                        <!-- Primary change question -->
                        <div fxLayout="column" fxLayoutGap="4px">
                          <h4>Has anything changed in your training program since your last approval? *</h4>
                          <mat-radio-group formControlName="reaccreditationHasChanges" data-focus-key="reaccreditation-has-changes">
                            <mat-radio-button [value]="true" [disabled]="!isFormEditable()">Yes</mat-radio-button>
                            <mat-radio-button [value]="false" style="margin-left: 16px;" [disabled]="!isFormEditable()">No</mat-radio-button>
                          </mat-radio-group>
                        </div>

                        <!-- Follow-up questions shown only when something changed -->
                        <ng-container *ngIf="hasReaccreditationChanges()">
                          <div fxLayout="column" fxLayoutGap="4px">
                            <h4>Changes Since Last Approval *</h4>
                            <mat-form-field appearance="fill" style="width: 100%;" [class.field-error]="atpApplicationForm.get('reaccreditationChangesSinceLastApproval')?.invalid && (atpApplicationForm.get('reaccreditationChangesSinceLastApproval')?.touched || atpApplicationForm.get('reaccreditationChangesSinceLastApproval')?.dirty)">
                              <mat-label>Please describe any changes to training facilities, equipment or course materials since the training program's last application was approved</mat-label>
                              <textarea matInput
                                        formControlName="reaccreditationChangesSinceLastApproval"
                                        rows="4"
                                        placeholder="Describe changes..."
                                        data-focus-key="reaccreditation-changes-since-last-approval"
                                        required>
                              </textarea>
                            </mat-form-field>
                          </div>

                          <div fxLayout="column" fxLayoutGap="4px">
                            <h4>Were any changes made to your course training materials or training location? *</h4>
                            <mat-radio-group formControlName="reaccreditationMaterialsOrLocationChanged" data-focus-key="reaccreditation-materials-or-location-changed">
                              <mat-radio-button [value]="true" [disabled]="!isFormEditable()">Yes</mat-radio-button>
                              <mat-radio-button [value]="false" style="margin-left: 16px;" [disabled]="!isFormEditable()">No</mat-radio-button>
                            </mat-radio-group>

                            <div fxLayout="column" fxLayoutGap="4px" style="margin-top: 8px;" *ngIf="showReaccreditationChangeCheckboxes()">
                              <span style="font-size: 14px; color: #555;">Select everything that changed:</span>
                              <mat-checkbox formControlName="reaccreditationTrainingMaterialsChanged" [disabled]="!isFormEditable()">Training Materials</mat-checkbox>
                              <mat-checkbox formControlName="reaccreditationTrainingLocationChanged" [disabled]="!isFormEditable()">Training Location</mat-checkbox>
                              <mat-error *ngIf="atpApplicationForm.get('reaccreditationMaterialsOrLocationChanged')?.hasError('requiredSelection')" style="font-size: 12px;">
                                <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle;">error</mat-icon>
                                Select Training Materials, Training Location, or both
                              </mat-error>
                            </div>
                          </div>

                          <div fxLayout="column" fxLayoutGap="4px">
                            <h4>Do you have a New Training Manager or Instructor? *</h4>
                            <mat-radio-group formControlName="reaccreditationHasNewStaff" data-focus-key="reaccreditation-has-new-staff">
                              <mat-radio-button [value]="true" [disabled]="!isFormEditable()">Yes</mat-radio-button>
                              <mat-radio-button [value]="false" style="margin-left: 16px;" [disabled]="!isFormEditable()">No</mat-radio-button>
                            </mat-radio-group>
                          </div>
                        </ng-container>

                        <!-- Required reaccreditation supporting documents -->
                        <div fxLayout="column" fxLayoutGap="16px">
                          <h4>Reaccreditation Documents</h4>

                          <ng-container *ngTemplateOutlet="reaccreditationDocumentArea; context: {
                            controlName: 'reaccreditationInstructorListDocuments',
                            title: 'List of All Current Instructors',
                            focusKey: 'reaccreditation-instructor-list-documents',
                            bannerText: 'Attach a document that contains a list of all current instructors.'
                          }"></ng-container>

                          <ng-container *ngTemplateOutlet="reaccreditationDocumentArea; context: {
                            controlName: 'reaccreditationCourseHistoryDocuments',
                            title: 'List of Last 25 Courses Held',
                            focusKey: 'reaccreditation-course-history-documents',
                            bannerText: 'Attach a document that contains a list of the last 25 courses held to include dates, number of students trained, instructor\'s name, location of training, and dates of pre and post training notifications submitted to OHA.'
                          }"></ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step *ngIf="showCourseDetailsStep()">
                    <ng-template matStepLabel>
                      <span>Course Details</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div style="padding: 0px;">
                        <!-- Course Materials and Testing Table -->
                        <div style="width: 100%; overflow-x: auto; margin-top: 8px;" *ngIf="courseDataSource.data.length > 0 && showCourseMaterialsSection()">
                      <h4>Course Training Materials</h4>
                      <p><strong>Curriculum</strong> - I certify that I am using the course training materials as marked below for each course for which I am seeking accreditation, as required by <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a href="https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225" target="_blank" style="color: #1976d2; text-decoration: underline;">40 CFR 745.225</a>).</p>
                      <p><strong>Course Test</strong> - I certify that I am using the course test as marked below for each course for which I am seeking accreditation.</p>
                      <!-- Instructional text banner for EPA/Other materials and tests -->
                      <mat-card class="info-banner">
                        <div fxLayout="column" fxLayoutGap="12px">
                          <!-- Assessment Documents Message (Always displayed) -->
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Assessment Documents -</strong> Attach a description of hands-on activities and procedures for assessing hands-on skills, including the following elements: List of hands-on topics covered, Activities performed for each hands-on topic, Procedures for evaluating student proficiency for each skill, Hands-on skills assessment sheet
                            </span>
                          </div>
                          
                          <!-- Quality Control Documents Message (Always displayed) -->
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Quality Control Documents -</strong> Attach a plan that contains the following elements: Procedures for periodic revision of training materials and course test to reflect regulatory changes & innovations in the field, Procedures for the training manager's annual review of principal instructor competency, Description of record-keeping procedures, notification procedures, and digital photograph submission procedures, Student-to-instructor ratio for hands-on training, Maximum class size.
                            </span>
                          </div>
                          
                          <!-- Certification Documents Message (Always displayed) -->
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Certification Documents -</strong> Attach documents for course completion certificate requirements, identification number protocol, and sample certificate.
                            </span>
                          </div>
                          
                          <!-- EPA Material Type Message -->
                          <div *ngIf="hasEPAMaterial()" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>EPA Material Type -</strong> Only submit a copy of any training materials you have added or changed from EPA model curriculum. Submit first 5 pages of student and instructor training manuals for each course. <strong>Curriculum must meet requirements in <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(d)(6)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(d)(6)' }}</a>.</strong>
                            </span>
                          </div>
                          
                          <!-- Other Material Type Message -->
                          <div *ngIf="hasOtherMaterial()" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Other Material Type -</strong> Submit a copy of your complete training curriculum, including complete student and instructor training manuals, course agenda with time allocation for each topic, and any other materials such as handouts to be used in class. <strong>Curriculum must meet requirements in <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(d)(6)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(d)(6)' }}</a>.</strong>
                            </span>
                          </div>
                          
                          <!-- EPA Test Type Message -->
                          <div *ngIf="hasEPATest()" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>EPA Test -</strong> Using current version of EPA model course test.
                            </span>
                          </div>
                          
                          <!-- Other Test Type Message -->
                          <div *ngIf="hasOtherTest()" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Other Test -</strong> Submit course test blueprint listing the portion of test questions devoted to each major course topic.
                            </span>
                          </div>
                        </div>
                      </mat-card>

                      <mat-card class="info-banner example-documents-card" style="margin: 8px 0 0 0;">
                        <div fxLayout="column" fxLayoutGap="12px">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <mat-icon style="color: #1976d2;">description</mat-icon>
                            <strong class="example-documents-title">Example Documents</strong>
                          </div>
                          <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                            Download example files for each required course document type.
                          </span>
                          <div fxLayout="row wrap" fxLayoutGap="8px">
                            <button mat-raised-button color="primary" type="button"
                                    *ngFor="let docType of exampleDocumentTypes"
                                    (click)="downloadExampleDocument(docType.key)"
                                  [disabled]="!hasExampleDocument(docType.key)"
                                  [matTooltip]="hasExampleDocument(docType.key) ? '' : 'No Example Available for Download'">
                              <mat-icon>download</mat-icon>
                              {{ docType.label }}
                            </button>
                          </div>
                        </div>
                      </mat-card>
                      
                      <mat-table [dataSource]="courseDataSource" class="mat-elevation-z8" style="table-layout: fixed;">
                        
                        <!-- Course Info Column -->
                        <ng-container matColumnDef="courseInfo">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Course Information</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="display: flex; align-items: center; padding: 8px;">
                            <div style="font-size: 12px; line-height: 1.3;">
                              {{ getCourseDisplayInfo(element) }}
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Material Type Column -->
                        <ng-container matColumnDef="courseMaterialType">
                          <mat-header-cell *matHeaderCellDef fxFlex="14">Material Type *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="14" style="margin-top: 15px; padding: 8px;">
                            <!-- Show dropdown when EPA is selected or null/empty -->
                            <mat-form-field appearance="fill" style="width: 100%; font-size: 12px;" 
                                            *ngIf="!shouldShowCustomTextInput(element)"
                                            [class.field-error]="hasFieldError(i, 'courseMaterialType')">
                              <mat-select [value]="element.courseMaterialType" 
                                          (selectionChange)="updateCourseMaterialType(i, $event.value)"
                                          style="font-size: 12px;" 
                                          data-focus-key="course-material-type"
                                          [disabled]="!isFormEditable()"
                                          required>
                                <mat-option [value]="null">--Select--</mat-option>
                                <mat-option *ngFor="let option of courseMaterialTypes" [value]="option.value">
                                  {{ option.label }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="element.formControl?.get('courseMaterialType')?.hasError('required')">
                                Material Type is required
                              </mat-error>
                            </mat-form-field>
                            <!-- Show text input when 'other' is selected OR when a custom value is loaded from DB -->
                            <mat-form-field appearance="fill" style="width: 100%; font-size: 12px;" 
                                            *ngIf="shouldShowCustomTextInput(element)">
                              <textarea matInput 
                                     #customTextInput
                                     placeholder="Describe Other" 
                                     [value]="element.courseMaterialTypeCustom"
                                     (input)="updateCourseMaterialTypeCustom(i, customTextInput.value)"
                                     [disabled]="!isFormEditable()"
                                     style="font-size: 12px; resize: none; overflow-y: auto;"
                                     rows="2"
                                     cdkTextareaAutosize
                                     cdkAutosizeMinRows="2"
                                     cdkAutosizeMaxRows="6"></textarea>
                              <button mat-icon-button matSuffix (click)="clearCourseMaterialTypeCustom(i); $event.stopPropagation()" *ngIf="!!isFormEditable()">
                                <mat-icon>close</mat-icon>
                              </button>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Material Documents Column -->
                        <ng-container matColumnDef="courseMaterialDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Material Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="display: flex; align-items: flex-start; padding: 8px;">
                            <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                              <!-- Upload Button at top - full width, left aligned -->
                              <div>
                                <input type="file" 
                                      #materialFileInput
                                      (change)="onCourseMaterialDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="materialFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="course-material-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <!-- Document List stacked underneath -->
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.courseMaterialDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadCourseDocument(i, docIndex, 'material')" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeCourseDocument(i, docIndex, 'material')"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.courseMaterialDocuments || element.courseMaterialDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                <mat-error *ngIf="element.formControl?.get('courseMaterialDocuments')?.hasError('requiredDocument')" style="font-size: 11px;">
                                  At least one document required
                                </mat-error>
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Test Type Column -->
                        <ng-container matColumnDef="courseTest">
                          <mat-header-cell *matHeaderCellDef fxFlex="14">Test Type *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="14" style="margin-top: 15px; padding: 8px;">
                            <!-- Show dropdown when EPA is selected or null/empty -->
                            <mat-form-field appearance="fill" style="width: 100%; font-size: 12px;" 
                                            *ngIf="!shouldShowCustomTestInput(element)"
                                            [class.field-error]="hasFieldError(i, 'courseTest')">
                              <mat-select [value]="element.courseTest" 
                                          (selectionChange)="updateCourseTest(i, $event.value)"
                                          style="font-size: 12px;" 
                                          data-focus-key="course-test-type"
                                          [disabled]="!isFormEditable()"
                                          required>
                                <mat-option [value]="null">--Select--</mat-option>
                                <mat-option *ngFor="let option of courseTestTypes" [value]="option.value">
                                  {{ option.label }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="element.formControl?.get('courseTest')?.hasError('required')">
                                Test Type is required
                              </mat-error>
                            </mat-form-field>
                            <!-- Show text input when 'other' is selected OR when a custom value is loaded from DB -->
                            <mat-form-field appearance="fill" style="width: 100%; font-size: 12px;" 
                                            *ngIf="shouldShowCustomTestInput(element)">
                              <textarea matInput 
                                     #customTestInput
                                     placeholder="Describe Other" 
                                     [value]="element.courseTestCustom"
                                     (input)="updateCourseTestCustom(i, customTestInput.value)"
                                     [disabled]="!isFormEditable()"
                                     style="font-size: 12px; resize: none; overflow-y: auto;"
                                     rows="2"
                                     cdkTextareaAutosize
                                     cdkAutosizeMinRows="2"
                                     cdkAutosizeMaxRows="6"></textarea>
                              <button mat-icon-button matSuffix (click)="clearCourseTestCustom(i); $event.stopPropagation()" *ngIf="!!isFormEditable()">
                                <mat-icon>close</mat-icon>
                              </button>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Test Documents Column -->
                        <ng-container matColumnDef="courseTestDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Test Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="display: flex; align-items: flex-start; padding: 8px;">
                            <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                              <div>
                                <input type="file" 
                                      #testFileInput
                                      (change)="onCourseTestDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="testFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="course-test-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.courseTestDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadCourseDocument(i, docIndex, 'test')" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeCourseDocument(i, docIndex, 'test')"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.courseTestDocuments || element.courseTestDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                <mat-error *ngIf="element.formControl?.get('courseTestDocuments')?.hasError('requiredDocument')" style="font-size: 11px;">
                                  At least one document required
                                </mat-error>
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Assessment Documents Column -->
                        <ng-container matColumnDef="courseAssessmentDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Assessment Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="display: flex; align-items: flex-start; padding: 8px;">
                            <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                              <div>
                                <input type="file" 
                                      #assessmentFileInput
                                      (change)="onCourseAssessmentDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="assessmentFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="course-assessment-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.courseAssessmentDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadCourseDocument(i, docIndex, 'assessment')" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeCourseDocument(i, docIndex, 'assessment')"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.courseAssessmentDocuments || element.courseAssessmentDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                <mat-error *ngIf="element.formControl?.get('courseAssessmentDocuments')?.hasError('requiredDocument')" style="font-size: 11px;">
                                  At least one document required
                                </mat-error>
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Quality Control Documents Column -->
                        <ng-container matColumnDef="courseQualityControlDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Quality Control Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="display: flex; align-items: flex-start; padding: 8px;">
                            <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                              <div>
                                <input type="file" 
                                      #qualityControlFileInput
                                      (change)="onCourseQualityControlDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="qualityControlFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="course-quality-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.courseQualityControlDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadCourseDocument(i, docIndex, 'qualityControl')" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeCourseDocument(i, docIndex, 'qualityControl')"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.courseQualityControlDocuments || element.courseQualityControlDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                <mat-error *ngIf="element.formControl?.get('courseQualityControlDocuments')?.hasError('requiredDocument')" style="font-size: 11px;">
                                  At least one document required
                                </mat-error>
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Certification Documents Column -->
                        <ng-container matColumnDef="courseCertificationDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Certification Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="display: flex; align-items: flex-start; padding: 8px;">
                            <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                              <div>
                                <input type="file" 
                                      #certificationFileInput
                                      (change)="onCourseCertificationDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="certificationFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="course-certification-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.courseCertificationDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadCourseDocument(i, docIndex, 'certification')" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeCourseDocument(i, docIndex, 'certification')"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.courseCertificationDocuments || element.courseCertificationDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                <mat-error *ngIf="element.formControl?.get('courseCertificationDocuments')?.hasError('requiredDocument')" style="font-size: 11px;">
                                  At least one document required
                                </mat-error>
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Header and Row Definitions -->
                        <mat-header-row *matHeaderRowDef="['courseInfo', 'courseMaterialType', 'courseMaterialDocuments', 'courseTest', 'courseTestDocuments', 'courseAssessmentDocuments', 'courseQualityControlDocuments', 'courseCertificationDocuments']"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: ['courseInfo', 'courseMaterialType', 'courseMaterialDocuments', 'courseTest', 'courseTestDocuments', 'courseAssessmentDocuments', 'courseQualityControlDocuments', 'courseCertificationDocuments'];" style="min-height: 60px;"></mat-row>
                      </mat-table>
                    </div>

                    <!-- Facility Information Table -->
                    <div style="width: 100%; overflow-x: auto; margin-top: 24px;" *ngIf="courseDataSource.data.length > 0 && showFacilitySection()">
                      <h4>Facility Information</h4>
                      <!-- Facility information banner -->
                      <mat-card class="info-banner">
                        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="12px">
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" style="flex: 1;">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              Add one or more facility addresses and assign courses to each location. Each course must be assigned to at least one location.
                            </span>
                          </div>
                          <button mat-raised-button color="primary" (click)="addFacilityLocation()" [disabled]="!isFormEditable()" data-focus-id="add-facility-address">
                            <mat-icon>add</mat-icon>
                            Add Facility Address
                          </button>
                        </div>
                      </mat-card>
                      <mat-table [dataSource]="facilityDataSource" matSort class="mat-elevation-z8" style="table-layout: fixed;">
                        
                        <!-- Course Info Column -->
                      <ng-container matColumnDef="courseInfo">
                        <mat-header-cell *matHeaderCellDef>Courses Assigned</mat-header-cell>
                        <mat-cell *matCellDef="let element; let i = index" style="margin-top: 15px;">
                          <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="hasFacilityFieldError(i, 'selectedCourseIds')">
                            <mat-select [value]="getFacilitySelectValues(i)"
                                        data-focus-key="facility-selected-courses"
                                        (selectionChange)="onFacilityCourseSelectionChange(i, $event.value)"
                                        multiple
                                        style="font-size: 12px;"
                                        [matTooltip]="getFacilitySelectedCourseTooltip(i)"
                                        matTooltipClass="multiline-tooltip"
                                        [disabled]="!isFormEditable()"
                                        required>
                              <mat-select-trigger>{{ getFacilitySelectedCourseDisplay(i) }}</mat-select-trigger>
                              <mat-option [value]="facilityAllCoursesValue">ALL</mat-option>
                              <mat-option *ngFor="let courseOption of getFacilityCourseOptions()" [value]="courseOption.id">
                                {{ courseOption.label }}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="element.formControl?.get('selectedCourseIds')?.hasError('requiredSelection')">
                              Select at least one course
                            </mat-error>
                          </mat-form-field>
                        </mat-cell>
                      </ng-container>

                        <!-- Street Column -->
                        <ng-container matColumnDef="street">
                          <mat-header-cell *matHeaderCellDef fxFlex="23">Street Address *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="23" style="margin-top: 15px;">
                            <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="hasFacilityFieldError(i, 'street')">
                              <input matInput 
                                    [formControl]="element.formControl.get('street')"
                                    [matAutocomplete]="autoFacilityAddress"
                                    #facilityStreetTrigger="matAutocompleteTrigger"
                                    placeholder="Enter street address"
                                    (input)="onFacilityStreetInput($event, i)"
                                    (focus)="onFacilityStreetFocus($event, i, facilityStreetTrigger)"
                                    style="font-size: 12px;" 
                                data-focus-key="facility-street"
                                    [readonly]="!isFormEditable()"
                                    required>
                              <mat-autocomplete #autoFacilityAddress="matAutocomplete">
                                <mat-option *ngFor="let addressOption of getFilteredFacilityAddressOptions(i)"
                                           [value]="addressOption.street"
                                           (onSelectionChange)="onFacilityAddressOptionSelected(i, addressOption)">
                                  {{ getFacilityAddressOptionLabel(addressOption) }}
                                </mat-option>
                              </mat-autocomplete>
                              <mat-error *ngIf="element.formControl?.get('street')?.hasError('required')">
                                Street Address is required
                              </mat-error>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- City Column -->
                        <ng-container matColumnDef="city">
                          <mat-header-cell *matHeaderCellDef fxFlex="15">City *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="margin-top: 15px;">
                            <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="hasFacilityFieldError(i, 'city')">
                              <input matInput 
                                    [formControl]="element.formControl.get('city')"
                                    placeholder="Enter city"
                                    style="font-size: 12px;" 
                                data-focus-key="facility-city"
                                    [readonly]="!isFormEditable()"
                                    required>
                              <mat-error *ngIf="element.formControl?.get('city')?.hasError('required')">
                                City is required
                              </mat-error>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- State Column -->
                        <ng-container matColumnDef="state">
                          <mat-header-cell *matHeaderCellDef fxFlex="8">State *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="8" style="margin-top: 15px;">
                            <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="hasFacilityFieldError(i, 'state')">
                              <mat-select [formControl]="element.formControl.get('state')"
                                          data-focus-key="facility-state"
                                          style="font-size: 12px;" 
                                          [disabled]="!isFormEditable()"
                                          required>
                                <mat-option [value]="null">--Select--</mat-option>
                                <mat-option *ngFor="let state of sharedService.states" [value]="state">
                                  {{ state }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="element.formControl?.get('state')?.hasError('required')">
                                State is required
                              </mat-error>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Zip Column -->
                        <ng-container matColumnDef="zip">
                          <mat-header-cell *matHeaderCellDef fxFlex="10">Zip Code *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="10" style="margin-top: 15px;">
                            <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="hasFacilityFieldError(i, 'zip')">
                              <input matInput 
                                    [formControl]="element.formControl.get('zip')"
                                    placeholder="Zip"
                                    style="font-size: 12px;" 
                                data-focus-key="facility-zip"
                                    [readonly]="!isFormEditable()"
                                    required>
                              <mat-error *ngIf="element.formControl?.get('zip')?.hasError('required')">
                                Zip Code is required
                              </mat-error>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Facility Type Column -->
                        <ng-container matColumnDef="facilityType">
                          <mat-header-cell *matHeaderCellDef fxFlex="12">Facility Type *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="12" style="margin-top: 15px;">
                            <mat-form-field appearance="fill" style="width: calc(100% - 8px); font-size: 12px;" [class.field-error]="hasFacilityFieldError(i, 'facilityType')">
                              <mat-select [formControl]="element.formControl.get('facilityType')"
                                          data-focus-key="facility-type"
                                          style="font-size: 12px;" 
                                          [disabled]="!isFormEditable()"
                                          required>
                                <mat-option [value]="null">--Select--</mat-option>
                                <mat-option *ngFor="let option of facilityTypes" [value]="option.value">
                                  {{ option.label }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="element.formControl?.get('facilityType')?.hasError('required')">
                                Facility Type is required
                              </mat-error>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Facility Documents Column -->
                        <ng-container matColumnDef="facilityDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="15">Facility Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="display: flex; align-items: flex-start; padding: 8px;">
                            <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                              <!-- Upload Button at top - full width, left aligned -->
                              <div>
                                <input type="file" 
                                      #facilityFileInput
                                      (change)="onFacilityDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="facilityFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="facility-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <!-- Document List stacked underneath -->
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.facilityDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadFacilityDocument(i, docIndex)" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeFacilityDocument(i, docIndex)"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.facilityDocuments || element.facilityDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                <mat-error *ngIf="element.formControl?.get('facilityDocuments')?.hasError('requiredDocument')" style="font-size: 11px;">
                                  At least one document required
                                </mat-error>

                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Actions Column -->
                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef fxFlex="8">Actions</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="8" style="display: flex; justify-content: center; align-items: center;">
                            <span [matTooltip]="facilityDataSource?.data?.length <= 1 ? 'At least 1 location is required' : ''"
                                  [matTooltipDisabled]="facilityDataSource?.data?.length > 1">
                              <button mat-icon-button color="warn"
                                      (click)="removeFacilityLocation(i)"
                                      [disabled]="!isFormEditable() || facilityDataSource?.data?.length <= 1">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </span>
                          </mat-cell>
                        </ng-container>

                        <!-- Header and Row Definitions -->
                        <mat-header-row *matHeaderRowDef="['courseInfo', 'street', 'city', 'state', 'zip', 'facilityType', 'facilityDocuments', 'actions']"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: ['courseInfo', 'street', 'city', 'state', 'zip', 'facilityType', 'facilityDocuments', 'actions'];" style="min-height: 60px;"></mat-row>
                      </mat-table>
                    </div>

                    <div style="width: 100%; overflow-x: auto; margin-top: 24px;" *ngIf="getFilteredCourseDataSource().length > 0 && showCourseMaterialsSection()">
                      <h4>Course additional documents</h4>
                      <!-- Additional documents banner for Non-English and Online courses -->
                      <mat-card *ngIf="hasNonEnglishCourse() || hasOnlineCourse()" class="info-banner">
                        <div fxLayout="column" fxLayoutGap="12px">
                          <!-- Non-English Course Message -->
                          <div *ngIf="hasNonEnglishCourse()" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Non-English Course -</strong> Attach A signed Statement of Authenticity to verify that a qualified, independent translator has compared the course to the English language version and found the translation to be accurate. Attach documentation of translator's qualifications.
                            </span>
                          </div>
                          
                          <!-- Online Course Message -->
                          <div *ngIf="hasOnlineCourse()" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>Online Course -</strong> Provide a link to the online course platform and any additional documentation required by the platform.
                            </span>
                          </div>
                        </div>
                      </mat-card>
                      <mat-table [dataSource]="getFilteredCourseDataSource()" class="mat-elevation-z8" style="table-layout: fixed;">
                        
                        <!-- Course Info Column -->
                        <ng-container matColumnDef="courseInfo">
                          <mat-header-cell *matHeaderCellDef fxFlex="25">Course Information</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="25" style="display: flex; align-items: center; padding: 8px;">
                            <div style="font-size: 12px; line-height: 1.4;">
                              {{ getCourseDisplayInfo(element) }}
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Language Documents Column -->
                        <ng-container matColumnDef="languageDocuments">
                          <mat-header-cell *matHeaderCellDef fxFlex="15">Language Documents *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="15" style="display: flex; align-items: flex-start; padding: 8px;">
                            
                            <!-- Show N/A when format is online but language is english -->
                            <div *ngIf="!shouldShowLanguageDocuments(element)" style="font-style: italic; color: #999; font-size: 12px;">
                              N/A
                            </div>
                            
                            <!-- Show upload functionality when format is online and language is not english -->
                            <div *ngIf="shouldShowLanguageDocuments(element)" fxLayout="column" fxLayoutGap="4px" style="width: 100%;"
                                 [class.field-error]="hasFieldError(i, 'languageDocuments')">
                              <!-- Upload Button at top - full width, left aligned -->
                              <div>
                                <input type="file" 
                                      #languageFileInput
                                      (change)="onLanguageDocumentSelected($event, i)"
                                      style="display: none;"
                                      accept=".pdf,.doc,.docx,.jpg,.png">
                                <button mat-raised-button color="primary" (click)="languageFileInput.click()" 
                                        style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                  data-focus-key="course-language-documents"
                                        [disabled]="!isFormEditable()">
                                  <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                  Upload
                                </button>
                              </div>
                              
                              <!-- Document List stacked underneath -->
                              <div fxLayout="column" fxLayoutGap="2px">
                                <div *ngFor="let doc of element.languageDocuments; let docIndex = index" 
                                    fxLayout="row" fxLayoutAlign="space-between center" 
                                    style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                  <a (click)="downloadLanguageDocument(i, docIndex)" 
                                    style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                    {{ doc.name }}
                                  </a>
                                  <button mat-icon-button color="warn" 
                                          (click)="removeLanguageDocument(i, docIndex)"
                                          style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                          [disabled]="!isFormEditable()">
                                    <mat-icon style="font-size: 12px;">close</mat-icon>
                                  </button>
                                </div>
                                
                                <div *ngIf="!element.languageDocuments || element.languageDocuments.length === 0" 
                                    style="font-size: 12px; color: #999; font-style: italic;">
                                  No documents
                                </div>
                                
                                <!-- Error message when required but empty -->
                                <div *ngIf="hasFieldError(i, 'languageDocuments')" 
                                     style="font-size: 11px; color: #f44336; margin-top: 4px;">
                                  At least one document required
                                </div>
                              </div>
                            </div>
                          </mat-cell>
                        </ng-container>

                        <!-- Course Website Column -->
                        <ng-container matColumnDef="courseWebsite">
                          <mat-header-cell *matHeaderCellDef fxFlex="30">Course Website *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="30" style="margin-top: 15px; padding: 8px;">
                            
                            <!-- Show N/A when format is not online -->
                            <div *ngIf="!shouldShowWebsiteFields(element)" style="font-style: italic; color: #999; font-size: 12px; display: flex; align-items: center; height: 100%;">
                              N/A
                            </div>
                            
                            <!-- Show input field when format is online -->
                            <mat-form-field *ngIf="shouldShowWebsiteFields(element)" appearance="fill" style="width: 100%; font-size: 12px;"
                                            [class.field-error]="hasFieldError(i, 'courseWebsite')">
                              <input matInput 
                                    [value]="element.courseWebsite" 
                                    (blur)="updateCourseWebsite(i, $any($event.target).value)"
                                    placeholder="Enter website URL"
                                    style="font-size: 12px;" 
                                data-focus-key="course-website"
                                    [readonly]="!isFormEditable()">
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Website Access Description Column -->
                        <ng-container matColumnDef="websiteAccessDescription">
                          <mat-header-cell *matHeaderCellDef fxFlex="30">Website Instructions *</mat-header-cell>
                          <mat-cell *matCellDef="let element; let i = index" fxFlex="30" style="margin-top: 15px; padding: 8px;">
                            
                            <!-- Show N/A when format is not online -->
                            <div *ngIf="!shouldShowWebsiteFields(element)" style="font-style: italic; color: #999; font-size: 12px; display: flex; align-items: center; height: 100%;">
                              N/A
                            </div>
                            
                            <!-- Show textarea when format is online -->
                            <mat-form-field *ngIf="shouldShowWebsiteFields(element)" appearance="fill" style="width: 100%; font-size: 12px;"
                                            [class.field-error]="hasFieldError(i, 'websiteAccessDescription')">
                              <textarea matInput 
                                        [value]="element.websiteAccessDescription" 
                                        (blur)="updateWebsiteAccessDescription(i, $any($event.target).value)"
                                        placeholder="Enter access instructions"
                                        rows="3"
                                        style="font-size: 12px;" 
                                        data-focus-key="course-website-instructions"
                                        [readonly]="!isFormEditable()">
                              </textarea>
                            </mat-form-field>
                          </mat-cell>
                        </ng-container>

                        <!-- Header and Row Definitions -->
                        <mat-header-row *matHeaderRowDef="['courseInfo', 'languageDocuments', 'courseWebsite', 'websiteAccessDescription']"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: ['courseInfo', 'languageDocuments', 'courseWebsite', 'websiteAccessDescription'];" style="min-height: 80px;"></mat-row>
                      </mat-table>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step>
                    <ng-template matStepLabel>
                      <span>Contact Info</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutGap="16px">
                        <h4>(NOTE: contact information in this section will be posted on the OHA Web site for parties interested in registering for classes).</h4>

                        <mat-card fxLayout="column" fxLayoutGap="8px">
                          <!-- Show notification if ATP is linked -->
                          <div *ngIf="isAtpLinked()" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="warning-banner-no-margin">
                            <mat-icon style="color: #e65100;">info</mat-icon>
                            <span style="color: #e65100; flex: 1;">This application is linked to an existing Training Provider. Address and contact information has been pre-populated.</span>
                            <button mat-icon-button color="warn" (click)="removeLinkedAtp()" matTooltip="Remove ATP link and clear all information">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          
                          <mat-form-field fxFlex="100%" appearance="fill">
                            <mat-label>Name of Company/Organization</mat-label>
                            <input matInput 
                                   formControlName="atpName" 
                                   [matAutocomplete]="autoAtp"
                                   [errorStateMatcher]="matcher"
                                   (input)="onAtpNameInput($event)"
                                   required>
                            <mat-error *ngIf="atpApplicationForm.get('atpName')?.hasError('required') && atpApplicationForm.get('atpName')?.touched">
                              Company/Organization name is required
                            </mat-error>
                            <mat-autocomplete #autoAtp="matAutocomplete">
                              <mat-option *ngFor="let atp of filteredAtpNames" 
                                         [value]="atp.name"
                                         (onSelectionChange)="selectAtpFromAutocomplete(atp)">
                                {{ getAtpDisplayName(atp) }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                          
                          <!-- Warning for exact match with Id == 0 -->
                          <mat-card *ngIf="showAtpWarning" style="padding: 12px; background-color: #fff3cd; border-left: 4px solid #ffc107; margin-bottom: 8px;">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                              <mat-icon style="color: #ff9800;">warning</mat-icon>
                              <span style="color: #856404;">{{ atpWarningMessage }}</span>
                            </div>
                          </mat-card> 

                          <span><strong>Physical Address</strong></span>
                          <div fxLayout="row" fxLayoutGap="8px">                    
                            <mat-form-field fxFlex="50" appearance="fill">
                              <mat-label>Street Apt/Unit/Suite</mat-label>
                              <input matInput formControlName="atpPhysicalStreet" [errorStateMatcher]="matcher" required>
                              <mat-error *ngIf="atpApplicationForm.get('atpPhysicalStreet')?.hasError('required') && atpApplicationForm.get('atpPhysicalStreet')?.touched">
                                Street address is required
                              </mat-error>
                            </mat-form-field>
                                
                            <mat-form-field fxFlex="25" appearance="fill">
                              <mat-label>City</mat-label>
                              <input matInput formControlName="atpPhysicalCity" [errorStateMatcher]="matcher" required>
                              <mat-error *ngIf="atpApplicationForm.get('atpPhysicalCity')?.hasError('required') && atpApplicationForm.get('atpPhysicalCity')?.touched">
                                City is required
                              </mat-error>
                            </mat-form-field>
            
                            <mat-form-field fxFlex="10" appearance="fill">                               
                              <mat-label>State</mat-label>
                              <mat-select formControlName="atpPhysicalState" [errorStateMatcher]="matcher" required>
                                <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="atpApplicationForm.get('atpPhysicalState')?.hasError('required') && atpApplicationForm.get('atpPhysicalState')?.touched">
                                State is required
                              </mat-error>
                            </mat-form-field>
            
                            <mat-form-field fxFlex="15" appearance="fill">
                              <mat-label>Zip</mat-label>
                              <input matInput formControlName="atpPhysicalZip" [errorStateMatcher]="matcher" required>
                              <mat-error *ngIf="atpApplicationForm.get('atpPhysicalZip')?.hasError('required') && atpApplicationForm.get('atpPhysicalZip')?.touched">
                                Zip code is required
                              </mat-error>
                            </mat-form-field>
            
                            <mat-form-field fxFlex="20" *ngIf="atpApplicationForm.get('atpPhysicalState').value === 'OR'" appearance="fill">
                              <mat-label>County</mat-label>
                              <mat-select formControlName="atpPhysicalCounty">
                                <mat-option>-- None --</mat-option>
                                <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div fxLayout="column">
                            <span><strong>Mailing Address</strong></span>
                            <div fxLayout="row" fxLayoutGap="8px">                    
                              <mat-checkbox  formControlName="mailingIsPhysical" (change)="mailingIsSame()">
                                Same as physical
                              </mat-checkbox>                                                          
                            </div>                
                            <div fxLayout="row" fxLayoutGap="8px" *ngIf="!atpApplicationForm.get('mailingIsPhysical').value">
                              <mat-form-field fxFlex="50" appearance="fill">
                                <mat-label>Street Apt/Unit/Suite</mat-label>
                                <input matInput formControlName="atpMailingStreet"
                                [errorStateMatcher]="matcher"
                                (blur)="validateFieldRequired(atpApplicationForm,'atpMailingStreet')" required>
                                <mat-error *ngIf="atpApplicationForm.get('atpMailingStreet')?.hasError('required') && atpApplicationForm.get('atpMailingStreet')?.touched">
                                  Street address is required
                                </mat-error>
                              </mat-form-field>
                                  
                              <mat-form-field fxFlex="25" appearance="fill">
                                <mat-label>City</mat-label>
                                <input matInput formControlName="atpMailingCity" [errorStateMatcher]="matcher" (blur)="validateFieldRequired(atpApplicationForm,'atpMailingCity')" required>
                                <mat-error *ngIf="atpApplicationForm.get('atpMailingCity')?.hasError('required') && atpApplicationForm.get('atpMailingCity')?.touched">
                                  City is required
                                </mat-error>
                              </mat-form-field>
              
                              <mat-form-field fxFlex="10" appearance="fill">
                                <mat-label>State</mat-label>
                                <mat-select formControlName="atpMailingState" [errorStateMatcher]="matcher" (blur)="validateFieldRequired(atpApplicationForm,'atpMailingState')" required>
                                  <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="atpApplicationForm.get('atpMailingState')?.hasError('required') && atpApplicationForm.get('atpMailingState')?.touched">
                                  State is required
                                </mat-error>
                              </mat-form-field>
              
                              <mat-form-field fxFlex="15" appearance="fill">
                                <mat-label>Zip</mat-label>
                                <input matInput formControlName="atpMailingZip" [errorStateMatcher]="matcher" (blur)="validateFieldRequired(atpApplicationForm,'atpMailingZip')" required>
                                <mat-error *ngIf="atpApplicationForm.get('atpMailingZip')?.hasError('required') && atpApplicationForm.get('atpMailingZip')?.touched">
                                  Zip code is required
                                </mat-error>
                              </mat-form-field>
              
                              <mat-form-field fxFlex="20" appearance="fill" *ngIf="atpApplicationForm.get('atpMailingState').value === 'OR'">                                
                                <mat-label>County</mat-label>
                                <mat-select formControlName="atpMailingCounty" >
                                  <mat-option>-- None --</mat-option>
                                  <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>                
                          </div>

                          <span><strong>Contact Information</strong></span>
                          
                          <!-- Show remove button if contact person is linked -->
                          <div *ngIf="isContactPersonLinked()" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="warning-banner-no-margin">
                            <mat-icon style="color: #e65100;">info</mat-icon>
                            <span style="color: #e65100; flex: 1;">This contact is linked to an ATP staff member.</span>
                            <button mat-icon-button color="warn" (click)="removeLinkedContactPerson()" matTooltip="Remove linked person">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          
                          <div fxLayout="row" fxLayoutGap="8px">
                            <mat-form-field fxFlex="33" appearance="fill">
                              <mat-label>Contact First Name</mat-label>
                              <input matInput 
                                     formControlName="atpContactFirstName"
                                     [matAutocomplete]="autoFirstName"
                                     #contactFirstNameTrigger="matAutocompleteTrigger"
                                     [errorStateMatcher]="matcher"
                                     (input)="onContactNameInput($event)"
                                     (focus)="onContactNameFocus($event, contactFirstNameTrigger)"
                                     required>
                              <mat-error *ngIf="atpApplicationForm.get('atpContactFirstName')?.hasError('required') && atpApplicationForm.get('atpContactFirstName')?.touched">
                                First name is required
                              </mat-error>
                              <mat-autocomplete #autoFirstName="matAutocomplete">
                                <mat-option *ngFor="let staff of filteredStaffMembers" 
                                           [value]="staff.person.firstName"
                                           (onSelectionChange)="selectStaffMember(staff)">
                                  {{ getStaffDisplayName(staff) }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>

                            <mat-form-field fxFlex="33" appearance="fill">
                              <mat-label>Contact Last Name</mat-label>
                              <input matInput 
                                     formControlName="atpContactLastName"
                                     [matAutocomplete]="autoLastName"
                                     #contactLastNameTrigger="matAutocompleteTrigger"
                                     [errorStateMatcher]="matcher"
                                     (input)="onContactNameInput($event)"
                                     (focus)="onContactNameFocus($event, contactLastNameTrigger)"
                                     required>
                              <mat-error *ngIf="atpApplicationForm.get('atpContactLastName')?.hasError('required') && atpApplicationForm.get('atpContactLastName')?.touched">
                                Last name is required
                              </mat-error>
                              <mat-autocomplete #autoLastName="matAutocomplete">
                                <mat-option *ngFor="let staff of filteredStaffMembers" 
                                           [value]="staff.person.lastName"
                                           (onSelectionChange)="selectStaffMember(staff)">
                                  {{ getStaffDisplayName(staff) }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field> 

                            <mat-form-field fxFlex="33" appearance="fill">
                              <mat-label>Contact Title</mat-label>
                              <input matInput formControlName="atpContactTitle">        
                            </mat-form-field> 
                          </div>
                          <div fxLayout="row" fxLayoutGap="8px">
                            <mat-form-field appearance="fill" fxFlex="33">
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="atpPhone" [errorStateMatcher]="matcher" required>
                            <mat-error *ngIf="atpApplicationForm.get('atpPhone')?.hasError('required') && atpApplicationForm.get('atpPhone')?.touched">
                              Phone is required
                            </mat-error>
                            </mat-form-field>
                            
                            <mat-form-field appearance="fill" fxFlex="33">
                            <mat-label>Alt Phone</mat-label>
                            <input matInput formControlName="atpAlternatePhone">
                            </mat-form-field>
                        
                            <mat-form-field appearance="fill" fxFlex="33">
                            <mat-label>Fax Phone</mat-label>
                            <input matInput formControlName="atpFaxPhone">
                            </mat-form-field>                            
                          </div>
      
                          <div fxLayout="row" fxLayoutGap="8px">
                            <mat-form-field appearance="fill" fxFlex="33">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="atpEmail" type="email" [errorStateMatcher]="matcher" required>
                            <mat-error *ngIf="atpApplicationForm.get('atpEmail')?.hasError('required') && atpApplicationForm.get('atpEmail')?.touched">
                              Email is required
                            </mat-error>
                            <mat-error *ngIf="atpApplicationForm.get('atpEmail')?.hasError('email') && atpApplicationForm.get('atpEmail')?.touched">
                              Invalid email format
                            </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill" fxFlex="33">
                            <mat-label>Confirm Email</mat-label>
                            <input matInput formControlName="atpConfirmEmail" type="email" [errorStateMatcher]="matcher" required>
                            <mat-error *ngIf="atpApplicationForm.get('atpConfirmEmail')?.hasError('required') && atpApplicationForm.get('atpConfirmEmail')?.touched">
                              Confirm email is required
                            </mat-error>
                            <mat-error *ngIf="atpApplicationForm.get('atpConfirmEmail')?.hasError('email') && atpApplicationForm.get('atpConfirmEmail')?.touched">
                              Invalid email format
                            </mat-error>
                            <mat-error *ngIf="atpApplicationForm.get('atpEmail')?.value !== atpApplicationForm.get('atpConfirmEmail')?.value && atpApplicationForm.get('atpConfirmEmail')?.touched && atpApplicationForm.get('atpConfirmEmail')?.value">
                              Emails must match
                            </mat-error>
                            </mat-form-field>                          
                            
                            <mat-form-field appearance="fill" fxFlex="33">
                            <mat-label>Website</mat-label>
                            <input matInput formControlName="atpWebsite">
                            </mat-form-field>                          
                          </div>
                        </mat-card>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step formArrayName="trainingManagers" *ngIf="showStaffStep()">
                    <ng-template matStepLabel>
                      <span>Staff</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutGap="16px">
                    <div fxLayout="column" fxLayoutGap="16px">
                      <!-- Add Staff Button -->
                      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" style="flex-wrap: wrap;">
                          <h3 style="margin: 0; display: flex; align-items: center; line-height: 1.2;">Training Manager ({{ trainingManagersFormArray.length }})</h3>
                        </div>
                        <button mat-raised-button color="primary" (click)="addTrainingManager()" [disabled]="!isFormEditable()" data-focus-id="add-training-manager">
                          <mat-icon>add</mat-icon> Add Training Manager
                        </button>
                      </div>

                      <!-- Staff Member Cards -->
                      <div *ngFor="let trainingManagerControl of trainingManagersFormArray.controls; let i = index" [formGroup]="$any(trainingManagerControl)" class="staff-card-container">                        
                        <mat-expansion-panel class="mat-elevation-4">
                          <!-- Accordion Header (Collapsed State) -->
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                                <!-- Staff Info Display -->
                                <div fxLayout="column">
                                  <span style="font-weight: 500; font-size: 16px;">
                                    {{ getTrainingManagerDisplayName(i) || 'Training Manager ' + (i + 1) }}
                                  </span>
                                  <span style="font-size: 12px; color: #666;">
                                    {{ getTotalDocuments(i) }} document(s) attached
                                  </span>
                                </div>
                                
                                <!-- Delete Button (visible when collapsed) -->
                                <button mat-icon-button color="warn" 
                                        (click)="removeTrainingManager(i); $event.stopPropagation();" 
                                        matTooltip="Delete Staff Member" 
                                        [disabled]="!isFormEditable()">
                                  <mat-icon>delete</mat-icon>
                                </button>
                              </div>
                            </mat-panel-title>
                          </mat-expansion-panel-header>

                          <!-- Accordion Content (Expanded State) -->
                          <div fxLayout="column">
                            <!-- Linked Staff Notification -->
                            <div *ngIf="isTrainingManagerLinked(i)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="warning-banner-no-margin">
                              <mat-icon style="color: #e65100;">info</mat-icon>
                              <span style="color: #e65100; flex: 1;">This training manager is linked to an ATP staff member.</span>
                              <button mat-icon-button color="warn" (click)="removeLinkedTrainingManager(i)" matTooltip="Remove staff link">
                                <mat-icon>close</mat-icon>
                              </button>
                            </div>
                            
                            <!-- Training Manager Eligibility Requirements Banner -->
                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner">
                              <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                              <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                <strong>TRAINING MANAGER ELIGIBILITY REQUIREMENTS</strong> - The training manager must meet the eligibility requirements described in <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(c)(1)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(c)(1)' }}</a>). Review those requirements and select the education and/or experience options in Sections 1 and 2 below that best describe the training manager's eligibility. You must submit the requested documentation with this application.
                              </span>
                            </div>
                            
                            <!-- Personal Information Section -->
                            <h4>Personal Information</h4>
                            <div fxLayout="column">
                              <div fxLayout="row" fxLayoutGap="8px">
                                <mat-form-field appearance="fill" fxFlex="33">
                                  <mat-label>First Name</mat-label>
                                  <input matInput 
                                         formControlName="firstName" 
                                         [matAutocomplete]="autoTMFirst"
                                         #trainingManagerFirstNameTrigger="matAutocompleteTrigger"
                                         (input)="onTrainingManagerNameInput($event, i)"
                                         (focus)="onTrainingManagerNameFocus($event, i, trainingManagerFirstNameTrigger)"
                                         required>
                                  <mat-autocomplete #autoTMFirst="matAutocomplete">
                                    <mat-option *ngFor="let staff of getFilteredTrainingManagers(i)" 
                                               [value]="staff.person.firstName"
                                               (onSelectionChange)="selectTrainingManagerStaff(staff, i)">
                                      {{ getStaffDisplayName(staff) }}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                                
                                <mat-form-field appearance="fill" fxFlex="33">
                                  <mat-label>Last Name</mat-label>
                                  <input matInput 
                                         formControlName="lastName" 
                                         [matAutocomplete]="autoTMLast"
                                         #trainingManagerLastNameTrigger="matAutocompleteTrigger"
                                         (input)="onTrainingManagerNameInput($event, i)"
                                         (focus)="onTrainingManagerNameFocus($event, i, trainingManagerLastNameTrigger)"
                                         required>
                                  <mat-autocomplete #autoTMLast="matAutocomplete">
                                    <mat-option *ngFor="let staff of getFilteredTrainingManagers(i)" 
                                               [value]="staff.person.lastName"
                                               (onSelectionChange)="selectTrainingManagerStaff(staff, i)">
                                      {{ getStaffDisplayName(staff) }}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                                
                                <mat-form-field appearance="fill" fxFlex="22">
                                  <mat-label>Middle Name</mat-label>
                                  <input matInput formControlName="middleName">
                                </mat-form-field>
                                
                                <mat-form-field appearance="fill" fxFlex="11">
                                  <mat-label>Title</mat-label>
                                  <input matInput formControlName="title">
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutGap="8px">
                                <mat-form-field appearance="fill" fxFlex="50">
                                  <mat-label>Phone</mat-label>
                                  <input matInput formControlName="phone" type="tel" required>
                                </mat-form-field>
                                
                                <mat-form-field appearance="fill" fxFlex="50">
                                  <mat-label>Email</mat-label>
                                  <input matInput formControlName="email" type="email" required>
                                </mat-form-field>
                              </div>                    
                            </div>

                            <!-- Training Table Section -->
                            <div style="margin-bottom: 4px;" formArrayName="trainingData">
                              <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 4px;">
                                <h4>Teaching Workers/Adults, Higher Education, Training Program Management Requirement <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(c)(1)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(c)(1)' }}</a>)</h4>
                                <button mat-raised-button color="accent" (click)="addTrainingRow(i)" [disabled]="!isFormEditable()">
                                  <mat-icon>add</mat-icon> Add Training
                                </button>
                              </div>
                              
                              <!-- Information Banner -->
                              <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner-no-margin">
                                <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                                <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                  Select the experience type, provide the years of experience, and provide supporting documentation (e.g., resume, diploma, transcripts).
                                </span>
                              </div>
                              
                              <div style="overflow-x: auto;">
                                <mat-table [dataSource]="getTrainingDataSource(i)" class="mat-elevation-z2" style="table-layout: fixed;">
                                  <!-- Type Column -->
                                  <ng-container matColumnDef="type">
                                    <mat-header-cell *matHeaderCellDef fxFlex="40">Experience *</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="40" [formGroup]="control" style="margin-top: 15px;">
                                      <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                        <mat-select formControlName="type">
                                          <mat-option [value]="null">--Select--</mat-option>
                                          <mat-option *ngFor="let option of trainingManagerTrainingDropdownOptions" [value]="option.value">
                                            {{ option.label }}
                                          </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="control.get('type')?.hasError('required') && (control.get('type')?.touched || control.get('type')?.dirty)">
                                          Experience is required
                                        </mat-error>
                                      </mat-form-field>
                                    </mat-cell>
                                  </ng-container>

                                  <!-- Description Column -->
                                  <ng-container matColumnDef="description">
                                    <mat-header-cell *matHeaderCellDef fxFlex="30">Years/Degree *</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="30" [formGroup]="control" style="margin-top: 15px;">
                                      <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                        <input matInput formControlName="description" [attr.placeholder]="control.get('type')?.value === 'highereducation' ? 'Bachelors or Graduate Degree' : 'Years of experience (Must be at least two years)'">
                                        <mat-error *ngIf="control.get('description')?.hasError('required') && (control.get('description')?.touched || control.get('description')?.dirty)">
                                          Years is required
                                        </mat-error>
                                      </mat-form-field>
                                    </mat-cell>
                                  </ng-container>

                                  <!-- Document Column -->
                                  <ng-container matColumnDef="document">
                                    <mat-header-cell *matHeaderCellDef fxFlex="20">Documents *</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="20" [formGroup]="control" style="display: flex; align-items: flex-start; padding: 8px;">
                                      <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                                        <!-- Upload Button at top - full width, left aligned -->
                                        <div>
                                          <input type="file" 
                                                #trainingFileInput
                                                (change)="onTrainingManagerDocumentSelected($event, i, 'training', idx)"
                                                style="display: none;"
                                                accept=".pdf,.doc,.docx,.jpg,.png">
                                          <button mat-raised-button color="primary" (click)="trainingFileInput.click()" 
                                                  style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                                  [disabled]="!isFormEditable()">
                                            <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                            Upload
                                          </button>
                                        </div>
                                        
                                        <!-- Document List stacked underneath -->
                                        <div fxLayout="column" fxLayoutGap="2px">
                                          <div *ngFor="let doc of control.get('documents')?.value; let docIndex = index" 
                                              fxLayout="row" fxLayoutAlign="space-between center" 
                                              style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                            <a (click)="downloadTrainingManagerDocument(i, 'training', idx, docIndex)" 
                                              style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                              {{ doc.name }}
                                            </a>
                                            <button mat-icon-button color="warn" 
                                                    (click)="removeTrainingManagerDocument(i, 'training', idx, docIndex)"
                                                    style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                                    [disabled]="!isFormEditable()">
                                              <mat-icon style="font-size: 12px;">close</mat-icon>
                                            </button>
                                          </div>
                                          
                                          <div *ngIf="!control.get('documents')?.value || control.get('documents')?.value.length === 0" 
                                              style="font-size: 12px; color: #999; font-style: italic;">
                                            No documents
                                          </div>
                                          <mat-error *ngIf="control.get('documents')?.hasError('requiredDocument') && (control.get('documents')?.touched || control.get('documents')?.dirty)" style="font-size: 11px;">
                                            At least one document required
                                          </mat-error>
                                        </div>
                                      </div>
                                    </mat-cell>
                                  </ng-container>

                                  <!-- Actions Column -->
                                  <ng-container matColumnDef="actions">
                                    <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="10">
                                        <span style="display: inline-flex;"
                                          [matTooltip]="(($any(trainingManagerControl.get('trainingData'))?.controls?.length || 0) <= 1) ? 'At least 1 training entry is required' : ''"
                                          [matTooltipDisabled]="($any(trainingManagerControl.get('trainingData'))?.controls?.length || 0) > 1">
                                        <button mat-icon-button color="warn"
                                                (click)="removeTrainingRow(i, idx)"
                                          [disabled]="!isFormEditable() || (($any(trainingManagerControl.get('trainingData'))?.controls?.length || 0) <= 1)">
                                          <mat-icon>delete</mat-icon>
                                        </button>
                                      </span>
                                    </mat-cell>
                                  </ng-container>

                                  <mat-header-row *matHeaderRowDef="['type', 'description', 'document', 'actions']"></mat-header-row>
                                  <mat-row *matRowDef="let row; columns: ['type', 'description', 'document', 'actions'];"></mat-row>
                                </mat-table>
                              </div>
                            </div>

                            <!-- Construction Table Section -->
                            <div formArrayName="constructionData">
                              <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 4px;">
                                <h4>Construction Industry Requirements <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(c)(1)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(c)(1)' }}</a>)</h4>
                                <button mat-raised-button color="accent" (click)="addConstructionRow(i)" [disabled]="!isFormEditable()">
                                  <mat-icon>add</mat-icon> Add Construction
                                </button>
                              </div>
                              
                              <!-- Information Banner -->
                              <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner-no-margin">
                                <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                                <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                  For the experience type, either select from the dropdown or type in a custom experience. Provide the years of experience, and provide supporting documentation (e.g., resume).
                                </span>
                              </div>
                              
                              <div style="overflow-x: auto;">
                                <mat-table [dataSource]="getConstructionDataSource(i)" class="mat-elevation-z2" style="table-layout: fixed;">
                                  <!-- Type Column -->
                                  <ng-container matColumnDef="type">
                                    <mat-header-cell *matHeaderCellDef fxFlex="40">Experience *</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="40" [formGroup]="control" style="margin-top: 15px;">
                                      <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                        <input type="text" 
                                               matInput 
                                               formControlName="type"
                                               (input)="filterTrainingManagerConstructionOptions(i, idx, $any($event.target).value); control.get('type')?.setValue($any($event.target).value)"
                                               placeholder="Type to search or select..."
                                               [matAutocomplete]="autoConstruction">
                                             <mat-autocomplete #autoConstruction="matAutocomplete"
                                                [displayWith]="displayConstructionTypeLabel"
                                                          (optionSelected)="updateTrainingManagerConstructionType(i, idx, $event.option.value)">
                                          <mat-option *ngFor="let option of getFilteredTrainingManagerConstructionOptions(i, idx)" [value]="option.value">
                                            {{ option.label }}
                                          </mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="control.get('type')?.hasError('required') && (control.get('type')?.touched || control.get('type')?.dirty)">
                                          Experience is required
                                        </mat-error>
                                      </mat-form-field>
                                    </mat-cell>
                                  </ng-container>

                                  <!-- Description Column -->
                                  <ng-container matColumnDef="description">
                                    <mat-header-cell *matHeaderCellDef fxFlex="30">Years *</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="30" [formGroup]="control" style="margin-top: 15px;">
                                      <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                        <input matInput formControlName="description" placeholder="Years of experience">
                                        <mat-error *ngIf="control.get('description')?.hasError('required') && (control.get('description')?.touched || control.get('description')?.dirty)">
                                          Years is required
                                        </mat-error>
                                      </mat-form-field>
                                    </mat-cell>
                                  </ng-container>

                                  <!-- Document Column -->
                                  <ng-container matColumnDef="document">
                                    <mat-header-cell *matHeaderCellDef fxFlex="20">Documents *</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="20" [formGroup]="control" style="display: flex; align-items: flex-start; padding: 8px;">
                                      <div fxLayout="column" fxLayoutGap="4px" style="width: 100%;">
                                        <!-- Upload Button at top - full width, left aligned -->
                                        <div>
                                          <input type="file" 
                                                #constructionFileInput
                                                (change)="onTrainingManagerDocumentSelected($event, i, 'construction', idx)"
                                                style="display: none;"
                                                accept=".pdf,.doc,.docx,.jpg,.png">
                                          <button mat-raised-button color="primary" (click)="constructionFileInput.click()" 
                                                  style="font-size: 12px; width: 100%; height: 32px; padding: 4px; text-align: left; justify-content: flex-start;" 
                                                  [disabled]="!isFormEditable()">
                                            <mat-icon style="font-size: 16px;">upload_file</mat-icon>
                                            Upload
                                          </button>
                                        </div>
                                        
                                        <!-- Document List stacked underneath -->
                                        <div fxLayout="column" fxLayoutGap="2px">
                                          <div *ngFor="let doc of control.get('documents')?.value; let docIndex = index" 
                                              fxLayout="row" fxLayoutAlign="space-between center" 
                                              style="background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                            <a (click)="downloadTrainingManagerDocument(i, 'construction', idx, docIndex)" 
                                              style="font-size: 12px; flex: 1; word-break: break-all; line-height: 1.1; cursor: pointer; color: #1976d2; text-decoration: underline;">
                                              {{ doc.name }}
                                            </a>
                                            <button mat-icon-button color="warn" 
                                                    (click)="removeTrainingManagerDocument(i, 'construction', idx, docIndex)"
                                                    style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                                    [disabled]="!isFormEditable()">
                                              <mat-icon style="font-size: 12px;">close</mat-icon>
                                            </button>
                                          </div>
                                          
                                          <div *ngIf="!control.get('documents')?.value || control.get('documents')?.value.length === 0" 
                                              style="font-size: 12px; color: #999; font-style: italic;">
                                            No documents
                                          </div>
                                          <mat-error *ngIf="control.get('documents')?.hasError('requiredDocument') && (control.get('documents')?.touched || control.get('documents')?.dirty)" style="font-size: 11px;">
                                            At least one document required
                                          </mat-error>
                                        </div>
                                      </div>
                                    </mat-cell>
                                  </ng-container>

                                  <!-- Actions Column -->
                                  <ng-container matColumnDef="actions">
                                    <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
                                    <mat-cell *matCellDef="let control; let idx = index" fxFlex="10">
                                        <span style="display: inline-flex;"
                                          [matTooltip]="(($any(trainingManagerControl.get('constructionData'))?.controls?.length || 0) <= 1) ? 'At least 1 construction entry is required' : ''"
                                          [matTooltipDisabled]="($any(trainingManagerControl.get('constructionData'))?.controls?.length || 0) > 1">
                                        <button mat-icon-button color="warn"
                                                (click)="removeConstructionRow(i, idx)"
                                          [disabled]="!isFormEditable() || (($any(trainingManagerControl.get('constructionData'))?.controls?.length || 0) <= 1)">
                                          <mat-icon>delete</mat-icon>
                                        </button>
                                      </span>
                                    </mat-cell>
                                  </ng-container>

                                  <mat-header-row *matHeaderRowDef="['type', 'description', 'document', 'actions']"></mat-header-row>
                                  <mat-row *matRowDef="let row; columns: ['type', 'description', 'document', 'actions'];"></mat-row>
                                </mat-table>
                              </div>
                            </div>
                          </div>
                        </mat-expansion-panel>
                      </div>
                    </div>


                    <div fxLayout="column" fxLayoutGap="16px">
                    <!-- Add Staff Button -->
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" style="flex-wrap: wrap;">
                        <h3 style="margin: 0; display: flex; align-items: center; line-height: 1.2;">Principal Instructor ({{ primaryInstructorsFormArray.length }})</h3>
                      </div>
                      <button mat-raised-button color="primary" (click)="addPrimaryInstructor()" [disabled]="!isFormEditable()" data-focus-id="add-primary-instructor">
                        <mat-icon>add</mat-icon> Add Principal Instructor
                      </button>
                    </div>

                    <!-- Principal Instructor Cards -->
                    <div *ngFor="let primaryInstructorControl of primaryInstructorsFormArray.controls; let i = index" [formGroup]="$any(primaryInstructorControl)" class="staff-card-container">                        
                      <mat-expansion-panel class="mat-elevation-4">
                        <!-- Accordion Header (Collapsed State) -->
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                              <!-- Staff Info Display -->
                              <div fxLayout="column">
                                <span style="font-weight: 500; font-size: 16px;">
                                  {{ getPrimaryInstructorDisplayName(i) || 'Principal Instructor ' + (i + 1) }}
                                </span>
                                <span style="font-size: 12px; color: #666;">
                                  {{ getTotalPrimaryInstructorDocuments(i) }} document(s) attached
                                </span>
                              </div>
                              
                              <!-- Delete Button (visible when collapsed) -->
                              <button mat-icon-button color="warn" 
                                      (click)="removePrimaryInstructor(i); $event.stopPropagation();" 
                                      matTooltip="Delete Principal Instructor" 
                                      [disabled]="!isFormEditable()">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <!-- Accordion Content (Expanded State) -->
                        <div fxLayout="column">
                          <!-- Linked Staff Notification -->
                          <div *ngIf="isPrimaryInstructorLinked(i)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="warning-banner-no-margin">
                            <mat-icon style="color: #e65100;">info</mat-icon>
                            <span style="color: #e65100; flex: 1;">This principal instructor is linked to an ATP staff member.</span>
                            <button mat-icon-button color="warn" (click)="removeLinkedPrimaryInstructor(i)" matTooltip="Remove staff link">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          
                          <!-- Principal Instructor Eligibility Requirements Banner -->
                          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner">
                            <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                            <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                              <strong>PRINCIPAL INSTRUCTOR ELIGIBILITY REQUIREMENTS</strong> - The principal instructor must meet the eligibility requirements described in <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(c)(2)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(c)(2)' }}</a>). Review those requirements and select the education and/or experience options in Sections 1, 2 and 3 below that best describe the principal instructor's eligibility. You must submit the requested documentation with this application.
                            </span>
                          </div>
                          
                          <!-- Personal Information Section -->
                          <h4>Personal Information</h4>
                          <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="8px">
                              <mat-form-field appearance="fill" fxFlex="33">
                                <mat-label>First Name</mat-label>
                                <input matInput 
                                       formControlName="firstName" 
                                       [matAutocomplete]="autoPIFirst"
                                      #primaryInstructorFirstNameTrigger="matAutocompleteTrigger"
                                       (input)="onPrimaryInstructorNameInput($event, i)"
                                      (focus)="onPrimaryInstructorNameFocus($event, i, primaryInstructorFirstNameTrigger)"
                                       required>
                                <mat-autocomplete #autoPIFirst="matAutocomplete">
                                  <mat-option *ngFor="let staff of getFilteredPrimaryInstructors(i)" 
                                             [value]="staff.person.firstName"
                                             (onSelectionChange)="selectPrimaryInstructorStaff(staff, i)">
                                    {{ getStaffDisplayName(staff) }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                              
                              <mat-form-field appearance="fill" fxFlex="33">
                                <mat-label>Last Name</mat-label>
                                <input matInput 
                                       formControlName="lastName" 
                                       [matAutocomplete]="autoPILast"
                                      #primaryInstructorLastNameTrigger="matAutocompleteTrigger"
                                       (input)="onPrimaryInstructorNameInput($event, i)"
                                      (focus)="onPrimaryInstructorNameFocus($event, i, primaryInstructorLastNameTrigger)"
                                       required>
                                <mat-autocomplete #autoPILast="matAutocomplete">
                                  <mat-option *ngFor="let staff of getFilteredPrimaryInstructors(i)" 
                                             [value]="staff.person.lastName"
                                             (onSelectionChange)="selectPrimaryInstructorStaff(staff, i)">
                                    {{ getStaffDisplayName(staff) }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                              
                              <mat-form-field appearance="fill" fxFlex="22">
                                <mat-label>Middle Name</mat-label>
                                <input matInput formControlName="middleName">
                              </mat-form-field>
                              
                              <mat-form-field appearance="fill" fxFlex="11">
                                <mat-label>Title</mat-label>
                                <input matInput formControlName="title">
                              </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutGap="8px">
                              <mat-form-field appearance="fill" fxFlex="50">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="phone" type="tel">
                              </mat-form-field>
                              
                              <mat-form-field appearance="fill" fxFlex="50">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email" type="email">
                              </mat-form-field>
                            </div>                    
                          </div>

                          <!-- Training Table Section -->
                          <div style="margin-bottom: 4px;" formArrayName="trainingData">
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 4px;">
                              <h4>Teaching Workers or Adults Requirement <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(c)(2)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(c)(2)' }}</a>)</h4>
                              <button mat-raised-button color="accent" (click)="addPrimaryInstructorTrainingRow(i)" [disabled]="!isFormEditable()">
                                <mat-icon>add</mat-icon> Add Training
                              </button>
                            </div>
                            
                            <!-- Information Banner -->
                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner-no-margin">
                              <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                              <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                Select the experience type, provide the years of experience, and provide supporting documentation (e.g., resume, diploma, transcripts).
                              </span>
                            </div>
                            
                            <div style="overflow-x: auto;">
                              <mat-table [dataSource]="getPrimaryInstructorTrainingDataSource(i)" class="mat-elevation-z2" style="table-layout: fixed;">
                                <!-- Type Column -->
                                <ng-container matColumnDef="type">
                                  <mat-header-cell *matHeaderCellDef fxFlex="40">Experience *</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="40" [formGroup]="control" style="margin-top: 15px;">
                                    <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                      <mat-select formControlName="type">
                                        <mat-option [value]="null">--Select--</mat-option>
                                        <mat-option *ngFor="let option of primaryInstructorTrainingDropdownOptions" [value]="option.value">
                                          {{ option.label }}
                                        </mat-option>
                                      </mat-select>
                                      <mat-error *ngIf="control.get('type')?.hasError('required') && (control.get('type')?.touched || control.get('type')?.dirty)">
                                        Experience is required
                                      </mat-error>
                                    </mat-form-field>
                                  </mat-cell>
                                </ng-container>

                                <!-- Description Column -->
                                <ng-container matColumnDef="description">
                                  <mat-header-cell *matHeaderCellDef fxFlex="30">Years *</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="30" [formGroup]="control" style="margin-top: 15px;">
                                    <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                      <input matInput formControlName="description" placeholder="Years of experience">
                                      <mat-error *ngIf="control.get('description')?.hasError('required') && (control.get('description')?.touched || control.get('description')?.dirty)">
                                        Years is required
                                      </mat-error>
                                    </mat-form-field>
                                  </mat-cell>
                                </ng-container>

                                <!-- Document Column -->
                                <ng-container matColumnDef="document">
                                  <mat-header-cell *matHeaderCellDef fxFlex="20">Document *</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="20" [formGroup]="control">
                                    <div style="width: 100%;">
                                      <input type="file" 
                                            #fileInput
                                            (change)="onPrimaryInstructorDocumentSelected($event, i, 'training', idx)"
                                            style="display: none;"
                                            accept=".pdf,.doc,.docx,.jpg,.png">
                                      
                                      <!-- Upload Button (full width) -->
                                      <button mat-raised-button color="primary" (click)="fileInput.click()" 
                                              style="width: 100%; margin-bottom: 8px;" 
                                              [disabled]="!isFormEditable()">
                                        <mat-icon>upload_file</mat-icon>
                                        Upload
                                      </button>
                                      
                                      <!-- Document List -->
                                      <div *ngIf="control.get('documents')?.value?.length > 0; else noDocuments">
                                        <div *ngFor="let document of control.get('documents')?.value; let docIdx = index" 
                                             style="display: flex; align-items: center; margin-bottom: 4px; background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                          <span (click)="downloadPrimaryInstructorDocument(i, 'training', idx, docIdx)" 
                                                style="cursor: pointer; text-decoration: underline; color: #1976d2; flex: 1; font-size: 11px; margin-right: 8px;">
                                            {{ document.name }}
                                          </span>
                                          <button mat-icon-button color="warn" 
                                                  (click)="removePrimaryInstructorDocument(i, 'training', idx, docIdx)"
                                                  matTooltip="Delete Document"
                                                  style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                                  [disabled]="!isFormEditable()">
                                            <mat-icon style="font-size: 12px;">close</mat-icon>
                                          </button>
                                        </div>
                                      </div>
                                      
                                      <ng-template #noDocuments>
                                        <div style="font-size: 11px; color: #666; font-style: italic;">
                                          No documents
                                        </div>
                                      </ng-template>
                                      <mat-error *ngIf="control.get('documents')?.hasError('requiredDocument') && (control.get('documents')?.touched || control.get('documents')?.dirty)" style="font-size: 11px;">
                                        At least one document required
                                      </mat-error>
                                    </div>
                                  </mat-cell>
                                </ng-container>

                                <!-- Actions Column -->
                                <ng-container matColumnDef="actions">
                                  <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="10" style="display: flex; align-items: center;">
                                    <span style="display: inline-flex;"
                                      [matTooltip]="(($any(primaryInstructorControl.get('trainingData'))?.controls?.length || 0) <= 1) ? 'At least 1 training entry is required' : ''"
                                      [matTooltipDisabled]="($any(primaryInstructorControl.get('trainingData'))?.controls?.length || 0) > 1">
                                      <button mat-icon-button color="warn"
                                              (click)="removePrimaryInstructorTrainingRow(i, idx)"
                                              [disabled]="!isFormEditable() || (($any(primaryInstructorControl.get('trainingData'))?.controls?.length || 0) <= 1)">
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                    </span>
                                  </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="['type', 'description', 'document', 'actions']"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ['type', 'description', 'document', 'actions'];"></mat-row>
                              </mat-table>
                            </div>
                          </div>

                          <!-- Principal Instructor Information Section -->
                          <div style="margin-bottom: 20px;">
                            <h4 style="margin-bottom: 16px;" *ngIf="atpApplicationForm.get('programType')?.value === 'lbpa'">Completion of (16 hrs) Accredited Lead-Specific Training Requirement <a href="https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">OAR 333-069</a> (and, by reference, <a href="https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">40 CFR 745.225</a>)</h4>
                            <h4 style="margin-bottom: 16px;" *ngIf="atpApplicationForm.get('programType')?.value === 'rrp'">Successful completion of at least (8 hrs) of any Lead-Based Paint Activities or Renovation, Repair and Painting training course from a training provider accredited by OHA, EPA or an EPA-authorized state or tribe.</h4>
                            
                            <!-- Information Banner -->
                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner-no-margin">
                              <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                              <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                Provide the training information and supporting documentation.
                              </span>
                            </div>
                            
                            <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column" fxLayoutGap.xs="8px">
                              <!-- Training Discipline -->
                              <mat-form-field appearance="fill" fxFlex="33" fxFlex.xs="100">
                                <mat-label>Training Discipline</mat-label>
                                <mat-select formControlName="trainingDiscipline" required>
                                  <mat-option [value]="null">--Select--</mat-option>
                                  <mat-option *ngFor="let discipline of getAllCourseDisciplines()" [value]="discipline">
                                    {{ discipline }}
                                  </mat-option>
                                </mat-select>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingDiscipline')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingDiscipline')?.touched || getPrimaryInstructorFormGroup(i).get('trainingDiscipline')?.dirty)">
                                  Training Discipline is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Name of Trainer -->
                              <mat-form-field appearance="fill" fxFlex="33" fxFlex.xs="100">
                                <mat-label>Name of Trainer</mat-label>
                                <input matInput formControlName="nameOfTrainer" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('nameOfTrainer')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('nameOfTrainer')?.touched || getPrimaryInstructorFormGroup(i).get('nameOfTrainer')?.dirty)">
                                  Name of Trainer is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Name of Training Program -->
                              <mat-form-field appearance="fill" fxFlex="34" fxFlex.xs="100">
                                <mat-label>Name of Training Program</mat-label>
                                <input matInput formControlName="nameOfTrainingProgram" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('nameOfTrainingProgram')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('nameOfTrainingProgram')?.touched || getPrimaryInstructorFormGroup(i).get('nameOfTrainingProgram')?.dirty)">
                                  Name of Training Program is required
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column" fxLayoutGap.xs="8px">
                              <!-- Training Street -->
                              <mat-form-field appearance="fill" fxFlex="40" fxFlex.xs="100">
                                <mat-label>Training Street Address</mat-label>
                                <input matInput formControlName="trainingStreet" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingStreet')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingStreet')?.touched || getPrimaryInstructorFormGroup(i).get('trainingStreet')?.dirty)">
                                  Training Street Address is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Training City -->
                              <mat-form-field appearance="fill" fxFlex="30" fxFlex.xs="100">
                                <mat-label>Training City</mat-label>
                                <input matInput formControlName="trainingCity" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingCity')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingCity')?.touched || getPrimaryInstructorFormGroup(i).get('trainingCity')?.dirty)">
                                  Training City is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Training State -->
                              <mat-form-field appearance="fill" fxFlex="15" fxFlex.xs="100">
                                <mat-label>State</mat-label>
                                <mat-select formControlName="trainingState" required>
                                  <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingState')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingState')?.touched || getPrimaryInstructorFormGroup(i).get('trainingState')?.dirty)">
                                  State is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Training Zip -->
                              <mat-form-field appearance="fill" fxFlex="15" fxFlex.xs="100">
                                <mat-label>Zip Code</mat-label>
                                <input matInput formControlName="trainingZip" maxlength="10" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingZip')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingZip')?.touched || getPrimaryInstructorFormGroup(i).get('trainingZip')?.dirty)">
                                  Zip Code is required
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column" fxLayoutGap.xs="8px">
                              <!-- Training Program Phone -->
                              <mat-form-field appearance="fill" fxFlex="33" fxFlex.xs="100">
                                <mat-label>Training Program Phone</mat-label>
                                <input matInput formControlName="trainingProgramPhone" type="tel" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingProgramPhone')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingProgramPhone')?.touched || getPrimaryInstructorFormGroup(i).get('trainingProgramPhone')?.dirty)">
                                  Training Program Phone is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Training Complete Date -->
                              <mat-form-field appearance="fill" fxFlex="33" fxFlex.xs="100">
                                <mat-label>Training Complete Date</mat-label>
                                <input matInput formControlName="trainingCompleteDate" type="date" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingCompleteDate')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingCompleteDate')?.touched || getPrimaryInstructorFormGroup(i).get('trainingCompleteDate')?.dirty)">
                                  Training Complete Date is required
                                </mat-error>
                              </mat-form-field>

                              <!-- Training Certificate ID -->
                              <mat-form-field appearance="fill" fxFlex="34" fxFlex.xs="100">
                                <mat-label>Training Certificate ID Number</mat-label>
                                <input matInput formControlName="trainingCertificateIdentificationNumber" required>
                                <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('trainingCertificateIdentificationNumber')?.hasError('required') && (getPrimaryInstructorFormGroup(i).get('trainingCertificateIdentificationNumber')?.touched || getPrimaryInstructorFormGroup(i).get('trainingCertificateIdentificationNumber')?.dirty)">
                                  Training Certificate ID Number is required
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <!-- Principal Instructor Documents -->
                            <div style="margin-top: 16px;">
                              <h5 style="margin-bottom: 12px;">Upload Documents *</h5>
                              <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column" fxLayoutGap.xs="8px" style="align-items: center;">
                                <!-- Upload Button Section -->
                                <div fxFlex="none">
                                  <input type="file" 
                                        #principalInstructorFileInput
                                        (change)="onPrincipalInstructorDocumentSelected($event, i)"
                                        style="display: none;"
                                        accept=".pdf,.doc,.docx,.jpg,.png"
                                        multiple>
                                  
                                  <button mat-raised-button color="primary" (click)="principalInstructorFileInput.click()" [disabled]="!isFormEditable()">
                                    <mat-icon>upload_file</mat-icon>
                                    Upload Documents
                                  </button>
                                </div>
                                
                                <!-- Document List Section -->
                                <div fxFlex="auto" style="min-width: 200px; max-width: 60%;">
                                  <div style="border: 1px solid #ddd; padding: 12px; border-radius: 4px; background-color: #fafafa; min-height: 50px; display: inline-block; min-width: 100%;">
                                    <div *ngIf="getPrimaryInstructorFormGroup(i).get('principalInstructorDocuments')?.value?.length > 0; else noPrincipalDocuments">
                                      <div *ngFor="let document of getPrimaryInstructorFormGroup(i).get('principalInstructorDocuments')?.value; let docIdx = index" 
                                           style="display: flex; align-items: center; margin-bottom: 4px; padding: 4px 8px; background-color: #f5f5f5; border-radius: 4px; box-sizing: border-box;">
                                        <span (click)="downloadPrincipalInstructorDocument(i, docIdx)" 
                                              style="cursor: pointer; text-decoration: underline; color: #1976d2; font-size: 12px; margin-right: 8px; white-space: nowrap;">
                                          {{ document.name }}
                                        </span>
                                        <button mat-icon-button color="warn" 
                                                (click)="removePrincipalInstructorDocument(i, docIdx)"
                                                matTooltip="Delete Document"
                                                style="width: 24px; height: 24px; flex-shrink: 0; margin-top: -15px;"
                                                [disabled]="!isFormEditable()">
                                          <mat-icon style="font-size: 16px;">close</mat-icon>
                                        </button>
                                      </div>
                                    </div>
                                    
                                    <ng-template #noPrincipalDocuments>
                                      <div style="font-size: 12px; color: #666; font-style: italic; text-align: center; padding: 8px;">
                                        No documents uploaded
                                      </div>
                                    </ng-template>
                                    <mat-error *ngIf="getPrimaryInstructorFormGroup(i).get('principalInstructorDocuments')?.hasError('requiredDocument') && (getPrimaryInstructorFormGroup(i).get('principalInstructorDocuments')?.touched || getPrimaryInstructorFormGroup(i).get('principalInstructorDocuments')?.dirty)" style="font-size: 11px; display: block; margin-top: 8px;">
                                      At least one document required
                                    </mat-error>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Construction Table Section -->
                          <div formArrayName="constructionData">
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 4px;">
                              <h4>Construction Industry Requirements <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://secure.sos.state.or.us/oard/viewSingleRule.action;JSESSIONID_OARD=RqPZ98wQSQGBgipDmaDI7ucsWxuFrhA43gVbQW8d0RJFhhuLy6kS!79857996?ruleVrsnRsn=59354' : 'https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=1279'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? 'OAR 333-069' : 'OAR 333-070' }}</a> (and, by reference, <a [href]="atpApplicationForm.get('programType')?.value === 'lbpa' ? 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#745.225' : 'https://www.ecfr.gov/current/title-40/chapter-I/subchapter-R/part-745#p-745.225(c)(2)'" target="_blank" rel="noopener" style="color: #1976d2; text-decoration: underline;">{{ atpApplicationForm.get('programType')?.value === 'lbpa' ? '40 CFR 745.225' : '40 CFR 745.225(c)(2)' }}</a>)</h4>
                              <button mat-raised-button color="accent" (click)="addPrimaryInstructorConstructionRow(i)" [disabled]="!isFormEditable()">
                                <mat-icon>add</mat-icon> Add Construction
                              </button>
                            </div>
                            
                            <!-- Information Banner -->
                            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="info-banner-no-margin">
                              <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
                              <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">
                                For the experience type, either select from the dropdown or type in a custom experience. Provide the years of experience, and provide supporting documentation (e.g., resume).
                              </span>
                            </div>
                            
                            <div style="overflow-x: auto;">
                              <mat-table [dataSource]="getPrimaryInstructorConstructionDataSource(i)" class="mat-elevation-z2" style="table-layout: fixed;">
                                <!-- Type Column -->
                                <ng-container matColumnDef="type">
                                  <mat-header-cell *matHeaderCellDef fxFlex="40">Experience *</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="40" [formGroup]="control" style="margin-top: 15px;">
                                    <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                      <input type="text" 
                                             matInput 
                                             formControlName="type"
                                             (input)="filterPrimaryInstructorConstructionOptions(i, idx, $any($event.target).value); control.get('type')?.setValue($any($event.target).value)"
                                             placeholder="Type to search or select..."
                                             [matAutocomplete]="autoConstructionPI">
                                         <mat-autocomplete #autoConstructionPI="matAutocomplete"
                                            [displayWith]="displayConstructionTypeLabel"
                                                        (optionSelected)="updatePrimaryInstructorConstructionType(i, idx, $event.option.value)">
                                        <mat-option *ngFor="let option of getFilteredPrimaryInstructorConstructionOptions(i, idx)" [value]="option.value">
                                          {{ option.label }}
                                        </mat-option>
                                      </mat-autocomplete>
                                      <mat-error *ngIf="control.get('type')?.hasError('required') && (control.get('type')?.touched || control.get('type')?.dirty)">
                                        Experience is required
                                      </mat-error>
                                    </mat-form-field>
                                  </mat-cell>
                                </ng-container>

                                <!-- Description Column -->
                                <ng-container matColumnDef="description">
                                  <mat-header-cell *matHeaderCellDef fxFlex="30">Years *</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="30" [formGroup]="control" style="margin-top: 15px;">
                                    <mat-form-field appearance="fill" style="width: calc(100% - 8px);">
                                      <input matInput formControlName="description" placeholder="Years of experience">
                                      <mat-error *ngIf="control.get('description')?.hasError('required') && (control.get('description')?.touched || control.get('description')?.dirty)">
                                        Years is required
                                      </mat-error>
                                    </mat-form-field>
                                  </mat-cell>
                                </ng-container>

                                <!-- Document Column -->
                                <ng-container matColumnDef="document">
                                  <mat-header-cell *matHeaderCellDef fxFlex="20">Document *</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="20" [formGroup]="control">
                                    <div style="width: 100%;">
                                      <input type="file" 
                                            #fileInput
                                            (change)="onPrimaryInstructorDocumentSelected($event, i, 'construction', idx)"
                                            style="display: none;"
                                            accept=".pdf,.doc,.docx,.jpg,.png">
                                      
                                      <!-- Upload Button (full width) -->
                                      <button mat-raised-button color="primary" (click)="fileInput.click()" 
                                              style="width: 100%; margin-bottom: 8px;" 
                                              [disabled]="!isFormEditable()">
                                        <mat-icon>upload_file</mat-icon>
                                        Upload Document
                                      </button>
                                      
                                      <!-- Document List -->
                                      <div *ngIf="control.get('documents')?.value?.length > 0; else noDocuments">
                                        <div *ngFor="let document of control.get('documents')?.value; let docIdx = index" 
                                             style="display: flex; align-items: center; margin-bottom: 4px; background-color: #f5f5f5; padding: 2px 4px; border-radius: 3px; min-height: 20px;">
                                          <span (click)="downloadPrimaryInstructorDocument(i, 'construction', idx, docIdx)" 
                                                style="cursor: pointer; text-decoration: underline; color: #1976d2; flex: 1; font-size: 11px; margin-right: 8px;">
                                            {{ document.name }}
                                          </span>
                                          <button mat-icon-button color="warn" 
                                                  (click)="removePrimaryInstructorDocument(i, 'construction', idx, docIdx)"
                                                  matTooltip="Delete Document"
                                                  style="width: 16px; height: 16px; font-size: 12px; margin-left: 2px; margin-top: -25px;" 
                                                  [disabled]="!isFormEditable()">
                                            <mat-icon style="font-size: 12px;">close</mat-icon>
                                          </button>
                                        </div>
                                      </div>
                                      
                                      <ng-template #noDocuments>
                                        <div style="font-size: 11px; color: #666; font-style: italic;">
                                          No documents
                                        </div>
                                      </ng-template>
                                      <mat-error *ngIf="control.get('documents')?.hasError('requiredDocument') && (control.get('documents')?.touched || control.get('documents')?.dirty)" style="font-size: 11px;">
                                        At least one document required
                                      </mat-error>
                                    </div>
                                  </mat-cell>
                                </ng-container>

                                <!-- Actions Column -->
                                <ng-container matColumnDef="actions">
                                  <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
                                  <mat-cell *matCellDef="let control; let idx = index" fxFlex="10" style="display: flex; align-items: center;">
                                    <span style="display: inline-flex;"
                                      [matTooltip]="(($any(primaryInstructorControl.get('constructionData'))?.controls?.length || 0) <= 1) ? 'At least 1 construction entry is required' : ''"
                                      [matTooltipDisabled]="($any(primaryInstructorControl.get('constructionData'))?.controls?.length || 0) > 1">
                                      <button mat-icon-button color="warn"
                                              (click)="removePrimaryInstructorConstructionRow(i, idx)"
                                              [disabled]="!isFormEditable() || (($any(primaryInstructorControl.get('constructionData'))?.controls?.length || 0) <= 1)">
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                    </span>
                                  </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="['type', 'description', 'document', 'actions']"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ['type', 'description', 'document', 'actions'];"></mat-row>
                              </mat-table>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>

                  <div fxLayout="column" fxLayoutGap="16px">
                    <!-- Add Staff Button -->
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" style="flex-wrap: wrap;">
                        <h3 style="margin: 0; display: flex; align-items: center; line-height: 1.2;">Guest Instructor ({{ guestInstructorsFormArray.length }})</h3>
                      </div>
                      <button mat-raised-button color="primary" (click)="addGuestInstructor()" [disabled]="!isFormEditable()" data-focus-id="add-guest-instructor">
                        <mat-icon>add</mat-icon> Add Guest Instructor
                      </button>
                    </div>

                    <!-- Guest Instructor Cards -->
                    <div *ngFor="let guestInstructorControl of guestInstructorsFormArray.controls; let i = index" [formGroup]="$any(guestInstructorControl)" class="staff-card-container">                        
                      <mat-expansion-panel class="mat-elevation-4">
                        <!-- Accordion Header (Collapsed State) -->
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                              <!-- Staff Info Display -->
                              <div fxLayout="column">
                                <span style="font-weight: 500; font-size: 16px;">
                                  {{ getGuestInstructorDisplayName(i) || 'Guest Instructor ' + (i + 1) }}
                                </span>
                                <span style="font-size: 12px; color: #666;">
                                  Guest Instructor
                                </span>
                              </div>
                              
                              <!-- Delete Button (visible when collapsed) -->
                              <button mat-icon-button color="warn" 
                                      (click)="removeGuestInstructor(i); $event.stopPropagation();" 
                                      matTooltip="Delete Guest Instructor" 
                                      [disabled]="!isFormEditable()">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>

                        <!-- Accordion Content (Expanded State) -->
                        <div fxLayout="column">
                          <!-- Linked Staff Notification -->
                          <div *ngIf="isGuestInstructorLinked(i)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="warning-banner-no-margin">
                            <mat-icon style="color: #e65100;">info</mat-icon>
                            <span style="color: #e65100; flex: 1;">This guest instructor is linked to an ATP staff member.</span>
                            <button mat-icon-button color="warn" (click)="removeLinkedGuestInstructor(i)" matTooltip="Remove staff link">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                          
                          <!-- Personal Information Section -->
                          <h4>Guest Instructor Information</h4>
                          <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="8px">
                              <mat-form-field appearance="fill" fxFlex="100">
                                <mat-label>Name</mat-label>
                                <input matInput 
                                       formControlName="name" 
                                       [matAutocomplete]="autoGIName"
                                  #guestInstructorNameTrigger="matAutocompleteTrigger"
                                       (input)="onGuestInstructorNameInput($event, i)"
                                  (focus)="onGuestInstructorNameFocus($event, i, guestInstructorNameTrigger)"
                                       required>
                                <mat-autocomplete #autoGIName="matAutocomplete">
                                  <mat-option *ngFor="let staff of getFilteredGuestInstructors(i)" 
                                             [value]="staff.person.firstName + ' ' + staff.person.lastName"
                                             (onSelectionChange)="selectGuestInstructorStaff(staff, i)">
                                    {{ getStaffDisplayName(staff) }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutGap="8px">
                              <mat-form-field appearance="fill" fxFlex="100">
                                <mat-label>Topic(s)</mat-label>
                                <input matInput formControlName="topics">
                              </mat-form-field>
                            </div>                    
                            <div fxLayout="row" fxLayoutGap="8px" style="margin-top: 4px;">
                              <mat-checkbox formControlName="handsOn">Hands-On</mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
                      </div>
                    </div>
                    </div>
                  </mat-step>

                  <mat-step>
                    <ng-template matStepLabel>
                      <span>Background</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div>                        
                        <div fxLayout="column" fxLayoutGap="4px">
                          <div fxLayout="column" fxLayoutGap="24px">                        
                            <h4>Does training program have any past, present, or pending lead-based paint activities (LBPA) or renovation, repair and painting (RRP) disciplinary action, suspension or citation of violations by any administrative agency, including but not limited to EPA, CCB, OSHA, or DEQ?</h4>                      
                            <mat-radio-group formControlName="hasViolation">
                              <mat-radio-button [value]="true">Yes</mat-radio-button>
                              <mat-radio-button [value]="false" style="margin-left: 16px;">No</mat-radio-button>
                            </mat-radio-group>
                            <mat-form-field appearance="fill" style="width: 100%;" *ngIf="atpApplicationForm.get('hasViolation')?.value === true" [class.field-error]="atpApplicationForm.get('violationDescription')?.invalid && (atpApplicationForm.get('violationDescription')?.touched || atpApplicationForm.get('violationDescription')?.dirty)">
                              <mat-label>Violation Description</mat-label>
                              <textarea matInput 
                                        formControlName="violationDescription"
                                        rows="4"
                                        placeholder="Please describe the violation details..."
                                        required>
                              </textarea>
                            </mat-form-field>
                            <h4>Additional Information</h4>                      
                            <mat-form-field appearance="fill" style="width: 100%;">
                              <mat-label>Please add any additional information or comments that you feel are relevant and would like OHA to consider with your application.</mat-label>
                              <textarea matInput 
                                        formControlName="additionalInformation"
                                        rows="4">
                              </textarea>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-step>

                  <mat-step>
                    <ng-template matStepLabel>
                      <span>Overview</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutGap="24px">
                      <h3>Application Review</h3>
                      
                      <!-- Information Banner -->
                      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="warning-banner-no-margin">
                        <mat-icon style="color: #e65100; flex-shrink: 0;">info</mat-icon>
                        <span style="color: #e65100; font-size: 14px; line-height: 1.5;">
                          Please review all information below before submitting your application.
                        </span>
                      </div>

                      <!-- Application Type Information -->
                      <mat-card fxLayout="column" fxLayoutGap="8px">
                        <!-- Header Card -->
                        <mat-card class="section-header-card">
                          <mat-card-title style="color: #0d47a1; font-size: 16px; display: flex; align-items: center; margin: 0;">
                            <mat-icon style="color: #1976d2; margin-right: 8px;">info</mat-icon>Application Information
                          </mat-card-title>
                        </mat-card>
                        <div fxLayout="row" fxLayoutGap="16px">
                          <span><strong>Application Type:</strong> {{ getApplicationTypeLabel() }}</span>
                          <span *ngIf="atpApplicationForm.get('applicationType')?.value === 'ammendment'">
                            <strong>Ammendment Type:</strong> {{ getAmmendmentTypeLabel() }}
                          </span>
                        </div>
                        <div fxLayout="row" fxLayoutGap="16px" *ngIf="atpApplicationForm.get('programType')?.value">
                          <span><strong>Program Type:</strong> {{ getProgramTypeLabel() }}</span>
                        </div>
                        <div *ngIf="atpApplicationForm.get('applicationType')?.value === 'ammendment' && atpApplicationForm.get('ammendmentType')?.value === 'other'">
                          <span><strong>Other Details:</strong> {{ atpApplicationForm.get('other')?.value }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutGap="16px">
                          <span><strong>Application Date:</strong> {{ getApplicationDateOrToday() | date:'MM/dd/yyyy' }}</span>
                        </div>
                      </mat-card>

                      <!-- Contact Information -->
                      <mat-card fxLayout="column" fxLayoutGap="8px">
                        <!-- Header Card -->
                        <mat-card class="section-header-card">
                          <mat-card-title style="color: #0d47a1; font-size: 16px; display: flex; align-items: center; margin: 0;">
                            <mat-icon style="color: #1976d2; margin-right: 8px;">contact_mail</mat-icon>Contact Information
                          </mat-card-title>
                        </mat-card>
                        <div><strong>Organization Name:</strong> {{ atpApplicationForm.get('atpName')?.value }}</div>
                        <div><strong>Physical Address:</strong> 
                          {{ atpApplicationForm.get('atpPhysicalStreet')?.value }}, 
                          {{ atpApplicationForm.get('atpPhysicalCity')?.value }}, 
                          {{ atpApplicationForm.get('atpPhysicalState')?.value }} 
                          {{ atpApplicationForm.get('atpPhysicalZip')?.value }}
                          <span *ngIf="atpApplicationForm.get('atpPhysicalCounty')?.value">, {{ atpApplicationForm.get('atpPhysicalCounty')?.value }} County</span>
                        </div>
                        <div *ngIf="!atpApplicationForm.get('mailingIsPhysical')?.value">
                          <strong>Mailing Address:</strong> 
                          {{ atpApplicationForm.get('atpMailingStreet')?.value }}, 
                          {{ atpApplicationForm.get('atpMailingCity')?.value }}, 
                          {{ atpApplicationForm.get('atpMailingState')?.value }} 
                          {{ atpApplicationForm.get('atpMailingZip')?.value }}
                          <span *ngIf="atpApplicationForm.get('atpMailingCounty')?.value">, {{ atpApplicationForm.get('atpMailingCounty')?.value }} County</span>
                        </div>
                        <div *ngIf="atpApplicationForm.get('mailingIsPhysical')?.value">
                          <strong>Mailing Address:</strong> Same as physical address
                        </div>
                        <div fxLayout="row" fxLayoutGap="16px">
                          <span><strong>Contact:</strong> {{ atpApplicationForm.get('atpContactFirstName')?.value }} {{ atpApplicationForm.get('atpContactLastName')?.value }}</span>
                          <span *ngIf="atpApplicationForm.get('atpContactTitle')?.value"><strong>Title:</strong> {{ atpApplicationForm.get('atpContactTitle')?.value }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutGap="16px">
                          <span><strong>Phone:</strong> {{ atpApplicationForm.get('atpPhone')?.value }}</span>
                          <span *ngIf="atpApplicationForm.get('atpAlternatePhone')?.value"><strong>Alt Phone:</strong> {{ atpApplicationForm.get('atpAlternatePhone')?.value }}</span>
                          <span *ngIf="atpApplicationForm.get('atpFaxPhone')?.value"><strong>Fax:</strong> {{ atpApplicationForm.get('atpFaxPhone')?.value }}</span>
                        </div>
                        <div fxLayout="row" fxLayoutGap="16px">
                          <span><strong>Email:</strong> {{ atpApplicationForm.get('atpEmail')?.value }}</span>
                          <span *ngIf="atpApplicationForm.get('atpWebsite')?.value"><strong>Website:</strong> {{ atpApplicationForm.get('atpWebsite')?.value }}</span>
                        </div>
                      </mat-card>

                      <!-- Course Information -->
                      <mat-card fxLayout="column" fxLayoutGap="8px" *ngIf="courseDataSource.data.length > 0">
                        <!-- Header Card -->
                        <mat-card class="section-header-card">
                          <mat-card-title style="color: #0d47a1; font-size: 16px; display: flex; align-items: center; margin: 0;">
                            <mat-icon style="color: #1976d2; margin-right: 8px;">class</mat-icon>Course Information
                          </mat-card-title>
                        </mat-card>
                        <div *ngFor="let course of courseDataSource.data; let i = index" style="border-bottom: 1px solid #e0e0e0; padding-bottom: 8px; margin-bottom: 8px;">
                          <div fxLayout="row" fxLayoutGap="16px">
                            <span><strong>Discipline:</strong> {{ course.discipline }}</span>
                            <span><strong>Type:</strong> {{ getTypeLabel(course.type) }}</span>
                            <span><strong>Language:</strong> {{ getLanguageLabel(course.language) }}</span>
                            <span><strong>Format:</strong> {{ getFormatLabel(course.format) }}</span>
                          </div>
                          <div fxLayout="row" fxLayoutGap="16px">
                            <span><strong>Accreditation:</strong> {{ getAccreditationLabel(course.accreditation) }}</span>
                            <span><strong>Fee:</strong> ${{ course.fee }}</span>
                          </div>
                          <div *ngIf="course.street || course.city || course.state || course.zip">
                            <strong>Facility Address:</strong> {{ course.street }}, {{ course.city }}, {{ course.state }} {{ course.zip }}
                          </div>
                        </div>
                        <mat-card class="mat-elevation-2" style="background-color: #e8f5e8; padding: 16px; margin-top: 16px; width: 100%;">
                          <div fxLayout="row" fxLayoutAlign="start center">
                            <span style="font-size: 14px; color: #666; font-weight: 500; margin-right: 8px;">Course Fees:</span>
                            <span style="font-size: 20px; font-weight: bold; color: #2e7d32;">
                              {{ getTotalFees() | currency:'USD':'symbol':'1.2-2' }}
                            </span>
                          </div>
                        </mat-card>
                      </mat-card>

                      <!-- Staff Information -->
                      <mat-card fxLayout="column" fxLayoutGap="16px" *ngIf="trainingManagersFormArray.length > 0 || primaryInstructorsFormArray.length > 0 || guestInstructorsFormArray.length > 0">
                        <!-- Header Card -->
                        <mat-card class="section-header-card">
                          <mat-card-title style="color: #0d47a1; font-size: 16px; display: flex; align-items: center; margin: 0;">
                            <mat-icon style="color: #1976d2; margin-right: 8px;">groups</mat-icon>Staff
                          </mat-card-title>
                        </mat-card>
                        <div *ngIf="trainingManagersFormArray.length > 0" fxLayout="column" fxLayoutGap="8px">
                          <div style="font-weight: 600;">
                            Training Managers ({{ trainingManagersFormArray.length }})
                          </div>
                          <div *ngFor="let manager of trainingManagersFormArray.controls; let i = index">
                            <span><strong>{{ i + 1 }}.</strong> {{ getTrainingManagerDisplayName(i) || 'Training Manager ' + (i + 1) }} - {{ getTotalDocuments(i) }} document(s)</span>
                          </div>
                        </div>

                        <div *ngIf="primaryInstructorsFormArray.length > 0" fxLayout="column" fxLayoutGap="8px">
                          <div style="font-weight: 600;">
                            Principal Instructors ({{ primaryInstructorsFormArray.length }})
                          </div>
                          <div *ngFor="let instructor of primaryInstructorsFormArray.controls; let i = index">
                            <span><strong>{{ i + 1 }}.</strong> {{ getPrimaryInstructorDisplayName(i) || 'Principal Instructor ' + (i + 1) }} - {{ getTotalPrimaryInstructorDocuments(i) }} document(s)</span>
                          </div>
                        </div>

                        <div *ngIf="guestInstructorsFormArray.length > 0" fxLayout="column" fxLayoutGap="8px">
                          <div style="font-weight: 600;">
                            Guest Instructors ({{ guestInstructorsFormArray.length }})
                          </div>
                          <div *ngFor="let instructor of guestInstructorsFormArray.controls; let i = index">
                            <span><strong>{{ i + 1 }}.</strong> {{ getGuestInstructorDisplayName(i) || 'Guest Instructor ' + (i + 1) }}</span>
                          </div>
                        </div>
                      </mat-card>

                      <!-- Background Information -->
                      <mat-card fxLayout="column" fxLayoutGap="8px">
                        <!-- Header Card -->
                        <mat-card class="section-header-card">
                          <mat-card-title style="color: #0d47a1; font-size: 16px; display: flex; align-items: center; margin: 0;">
                            <mat-icon style="color: #1976d2; margin-right: 8px;">assignment</mat-icon>Background Information
                          </mat-card-title>
                        </mat-card>
                        <div>
                          <strong>Other Jurisdiction Accreditations:</strong> 
                          {{ atpApplicationForm.get('otherJurisdictionAccreditation')?.value ? 'Yes (' + otherAccreditationsFormArray.length + ' listed)' : 'No' }}
                        </div>
                        <div>
                          <strong>Past Violations:</strong> 
                          {{ atpApplicationForm.get('hasViolation')?.value ? 'Yes' : 'No' }}
                        </div>
                        <div *ngIf="atpApplicationForm.get('hasViolation')?.value && atpApplicationForm.get('violationDescription')?.value">
                          <strong>Violation Details:</strong> {{ atpApplicationForm.get('violationDescription')?.value }}
                        </div>
                        <div *ngIf="atpApplicationForm.get('additionalInformation')?.value">
                          <strong>Additional Information:</strong> {{ atpApplicationForm.get('additionalInformation')?.value }}
                        </div>
                      </mat-card>

                      <!-- Reaccreditation Information (only show if reaccreditation type) -->
                      <mat-card fxLayout="column" fxLayoutGap="8px" *ngIf="atpApplicationForm.get('applicationType')?.value === 'reaccreditation'">
                        <h4>Reaccreditation Information</h4>
                        <div>
                          Instructor and course renewal details are being carried forward automatically for this application.
                        </div>
                        <div *ngIf="atpApplicationForm.get('reaccreditationChangesSinceLastApproval')?.value">
                          <strong>Changes Since Last Approval:</strong> {{ atpApplicationForm.get('reaccreditationChangesSinceLastApproval')?.value }}
                        </div>
                        <div>
                          <strong>Anything changed since last approval:</strong> {{ hasReaccreditationChanges() ? 'Yes' : 'No' }}
                        </div>
                        <div *ngIf="hasReaccreditationChanges()">
                          <strong>Course training materials or training location changed:</strong> {{ atpApplicationForm.get('reaccreditationMaterialsOrLocationChanged')?.value === true ? 'Yes' : 'No' }}
                        </div>
                        <div *ngIf="showReaccreditationChangeCheckboxes()">
                          <strong>What changed:</strong>
                          <span *ngIf="isReaccreditationTrainingMaterialsChanged()">Training Materials</span>
                          <span *ngIf="isReaccreditationTrainingMaterialsChanged() && isReaccreditationTrainingLocationChanged()">, </span>
                          <span *ngIf="isReaccreditationTrainingLocationChanged()">Training Location</span>
                        </div>
                        <div *ngIf="hasReaccreditationChanges()">
                          <strong>New Training Manager or Instructor:</strong> {{ hasNewReaccreditationStaff() ? 'Yes' : 'No' }}
                        </div>
                        <div>
                          <strong>List of all current instructors:</strong> {{ getReaccreditationDocuments('reaccreditationInstructorListDocuments').length }} document(s)
                        </div>
                        <div>
                          <strong>List of last 25 courses held:</strong> {{ getReaccreditationDocuments('reaccreditationCourseHistoryDocuments').length }} document(s)
                        </div>
                      </mat-card>

                      <mat-card class="mat-elevation-2" style="background-color: #e8f5e8; padding: 16px; width: 100%;">
                        <div fxLayout="row" fxLayoutAlign="start center">
                          <span style="font-size: 14px; color: #666; font-weight: 500; margin-right: 8px;">Grand Total:</span>
                          <span style="font-size: 20px; font-weight: bold; color: #2e7d32;">
                            {{ getGrandTotalFees() | currency:'USD':'symbol':'1.2-2' }}
                          </span>
                        </div>
                      </mat-card>

                      <!-- Attestation Section -->
                      <mat-card class="attestation-card" fxLayout="column" fxLayoutGap="16px" style="border: 2px solid #ff5722;">
                        <h4 style="color: #ff5722;">Attestation and Electronic Signature</h4>
                        
                        <div class="attestation-notice" style="background-color: #fff3e0; padding: 16px; border-radius: 4px;">
                          <p><strong>By checking the box below and providing your electronic signature, you attest that:</strong></p>
                          <ul>
                            <li>All information provided in this application is true and accurate to the best of your knowledge</li>
                            <li>You understand that false statements may result in denial or revocation of accreditation</li>
                            <li>You agree to comply with all applicable regulations and requirements</li>
                            <li>You have the authority to submit this application on behalf of the organization</li>
                          </ul>
                        </div>

                        <mat-checkbox formControlName="attestation" color="primary" style="margin: 16px 0;">
                          <strong>I attest that the information provided is true and accurate</strong>
                        </mat-checkbox>

                        <mat-form-field appearance="fill" style="width: 100%;">
                          <mat-label>Electronic Signature (Type your full name)</mat-label>
                          <input matInput 
                                formControlName="esignature" 
                                placeholder="Type your full legal name as your electronic signature"
                                required>
                          <mat-error *ngIf="atpApplicationForm.get('esignature')?.hasError('required')">
                            Electronic signature is required
                          </mat-error>
                        </mat-form-field>

                        <div style="font-size: 12px; color: #666; font-style: italic;">
                          By typing your name above, you are providing your electronic signature in accordance with applicable electronic signature laws.
                        </div>

                        <div *ngIf="atpApplicationForm.get('attestation')?.hasError('required') && atpApplicationForm.get('attestation')?.touched"
                             style="color: #f44336; font-size: 12px; margin-top: 8px;">
                          You must check the attestation box to proceed
                        </div>
                      </mat-card>

                      <!-- Submit Button -->
                      <div *ngIf="showSubmitButton()" fxLayout="row" fxLayoutAlign="center center" style="margin-top: 32px;">
                        <button mat-raised-button 
                                color="primary"
                                (click)="submitApplication()" 
                                style="font-size: 16px; padding: 12px 32px;">
                          <mat-icon>send</mat-icon>
                          Submit Application
                        </button>
                      </div>
                      </div>
                    </div>
                  </mat-step>

                  <!-- Follow-up Confirmation Step -->
                  <mat-step *ngIf="atpApplicationForm.get('applicationStatus')?.value === 'Submitted'">
                    <ng-template matStepLabel>
                      <span>Confirmation</span>
                    </ng-template>
                    <div class="scroll-container">
                      <div fxLayout="column" fxLayoutAlign="center center" style="padding: 40px; text-align: center;">
                      <mat-card style="padding: 30px; max-width: 600px;">
                        <mat-card-content style="display: flex; flex-direction: column; align-items: center;">
                          <mat-icon style="font-size: 64px; height: 64px; width: 64px; color: #4caf50; margin-bottom: 20px;">check_circle</mat-icon>
                          <h2 style="color: #4caf50; margin-bottom: 20px;">Application Submitted Successfully!</h2>
                          <p style="font-size: 16px; line-height: 1.6; margin-bottom: 20px;">
                            Your application has been submitted and is being reviewed. 
                            If you have any questions or concerns, please contact us at:
                          </p>
                          <div style="padding: 16px; border-radius: 4px; margin-bottom: 20px;">
                            <p style="margin: 4px 0;"><strong>Email: </strong> 
                              <a href="mailto:leadprogram@odhsoha.oregon.gov" style="color: #1976d2;">leadprogram@odhsoha.oregon.gov</a>
                            </p>
                            <p style="margin: 4px 0;"><strong>Phone: </strong> 
                              <a href="tel:971-673-0440" style="color: #1976d2;">971-673-0440</a>
                            </p>
                          </div>
                        </mat-card-content>
                      </mat-card>
                      </div>
                    </div>
                  </mat-step>

                </mat-stepper>                                                  
            </div>
        </form>

        <div
          *ngIf="selectedApplicationType !== '' && (atpApplicationForm.get('applicationFeedback')?.value || hasValidationErrors())"
          class="validation-summary"
          [class.collapsed]="isFeedbackCollapsed">
          <button
            type="button"
            class="validation-summary-header validation-summary-toggle"
            (click)="toggleFeedbackPanel()"
            [attr.aria-expanded]="!isFeedbackCollapsed"
            [attr.aria-label]="isFeedbackCollapsed ? 'Expand deficiencies panel' : 'Minimize deficiencies panel'">
            <span class="validation-summary-title">
              <mat-icon>warning</mat-icon>
              <span>Application Feedback / Deficiencies</span>
            </span>
            <span class="validation-summary-action">{{ isFeedbackCollapsed ? 'Expand' : 'Minimize' }}</span>
          </button>
          <div
            *ngIf="!isFeedbackCollapsed"
            #deficiencyCard
            class="deficiency-card">
            <div class="validation-feedback-section" *ngIf="getPersistedFeedbackText()">
              <div class="feedback-text">{{ getPersistedFeedbackText() }}</div>
            </div>

            <ng-container *ngIf="getValidationFeedbackGroups() as validationGroups">
              <div class="validation-feedback-section" *ngIf="validationGroups.length > 0">
                <div class="validation-feedback-heading">Missing Required Fields</div>
                <div class="validation-feedback-group" *ngFor="let validationGroup of validationGroups">
                  <div class="validation-feedback-step">{{ validationGroup.step }}</div>
                  <div class="validation-feedback-links">
                    <button
                      type="button"
                      class="validation-feedback-link"
                      *ngFor="let validationError of validationGroup.errors"
                      (click)="focusValidationFeedbackError(validationError)">
                      {{ validationError.label }}
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

    <mat-card class="action-card" [style.background-color]="uiData.atp.color" fxLayoutGap="8px">                        
        <button (click)="onExitClick()" mat-raised-button aria-label="Exit">{{'Exit' | translate}}</button>
        <button (click)="cancelApplication()" *ngIf="selectedApplicationType=='new' || selectedApplicationType=='link'" mat-raised-button color="warn" [disabled]="isCancelButtonDisabled()" [attr.aria-label]="getCancelButtonText()">{{getCancelButtonText() | translate}}</button>
        <button (click)="saveAtpApplication()" *ngIf="selectedApplicationType=='new'" mat-raised-button color="primary" aria-label="Save" [disabled]="!isFormEditable()">{{'Save Application' | translate}}</button>                      
        <div fxFlex="1 1 auto"></div>
        <button *ngIf="showPreviousButton()" mat-raised-button (click)="goToPreviousStep()" [disabled]="loading">Previous</button>
        <button *ngIf="showNextButton()" mat-raised-button color="primary" (click)="goToNextStep()" [disabled]="loading">Next</button>
        <button *ngIf="showSubmitButton()" mat-raised-button color="primary" (click)="submitApplication()" [disabled]="!isFormEditable()">{{selectedApplicationType === 'link' ? 'Submit Link Request' : 'Submit Application'}}</button>
    </mat-card>
</div>

<!-- Reusable required document upload area used by the ReAccredit step -->
<ng-template #reaccreditationDocumentArea let-controlName="controlName" let-title="title" let-focusKey="focusKey" let-bannerText="bannerText">
  <div fxLayout="column" fxLayoutGap="8px" style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 16px;">
    <h5 style="margin: 0;">{{ title }} *</h5>

    <mat-card class="info-banner">
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
        <mat-icon style="color: #1976d2; flex-shrink: 0;">info</mat-icon>
        <span style="color: #0d47a1; font-size: 14px; line-height: 1.5;">{{ bannerText }}</span>
      </div>
    </mat-card>

    <div>
      <input type="file"
             #reaccreditationFileInput
             (change)="onReaccreditationDocumentSelected($event, controlName)"
             style="display: none;"
             accept=".pdf,.doc,.docx,.jpg,.png">
      <button mat-raised-button color="primary"
              (click)="reaccreditationFileInput.click()"
              [attr.data-focus-key]="focusKey"
              [disabled]="!isFormEditable()">
        <mat-icon style="font-size: 16px;">upload_file</mat-icon>
        Upload
      </button>
    </div>

    <div fxLayout="column" fxLayoutGap="4px">
      <div *ngFor="let doc of getReaccreditationDocuments(controlName); let docIndex = index"
           fxLayout="row" fxLayoutAlign="space-between center"
           style="background-color: #f5f5f5; padding: 4px 8px; border-radius: 3px;">
        <a (click)="downloadReaccreditationDocument(controlName, docIndex)"
           style="font-size: 13px; flex: 1; word-break: break-all; cursor: pointer; color: #1976d2; text-decoration: underline;">
          {{ doc.name }}
        </a>
        <button mat-icon-button color="warn"
                (click)="removeReaccreditationDocument(controlName, docIndex)"
                [disabled]="!isFormEditable()">
          <mat-icon style="font-size: 16px;">close</mat-icon>
        </button>
      </div>

      <div *ngIf="getReaccreditationDocuments(controlName).length === 0"
           style="font-size: 13px; color: #999; font-style: italic;">
        No documents
      </div>

      <mat-error *ngIf="atpApplicationForm.get(controlName)?.hasError('requiredDocument')" style="font-size: 12px;">
        <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle;">error</mat-icon>
        At least one document is required
      </mat-error>
    </div>
  </div>
</ng-template>

